<template>
    <!--  <div style="margin-top:0px;" :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'">-->
    <div style="margin-top:0px;" :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'">
        <Header/>
        <div
            :class="$i18n.locale=='العربية'?'FrameWork__PageWrapper-v8gq48-13 eRmiUC':'FrameWork__PageWrapper-v8gq48-13 obiMX'" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important; '">
            <section class="style__SpotlightInnerWrap-sc-1qapdh8-0 kKgHVc">
                <div class="spotlight" :style="$i18n.locale == 'العربية' ?'float:right;width:100%;':'float:left;width:100%;'">
                    <div class="style__SpotlightItemStyled-vo40go-0 cDscbW">
                        <figure>
                            <div class=" gatsby-image-wrapper" style="position:relative;overflow:hidden">
                                <div aria-hidden="true" style="width:100%;padding-bottom:49.5%"></div>

                                <picture v-if="this.pagedata"><img
                                              :src="this.serverurl+'/public/pagebanners/'+pagedata.pagebanner"
                                              alt=""
                                              style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>

                                </picture>


                               <!--            <video style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"-->
<!--                   v-if="this.pagedata && this.pagedata.id==51"  width="100%"-->
<!--                   height="100%" autoplay loop>-->
<!--                <source :src="this.serverurl+'/public/pagebanners/scalping.webm'" type="video/webm" style="position:absolute;top:0;left:0;opacity:1;min-width:100%;min-height:100%;object-fit:cover;object-position:center" />-->
<!--                Your browser does not support the video tag.-->
<!--            </video>-->

                            </div>
                        </figure>
                        <div class="spotlight__info" :style="$i18n.locale == 'العربية' ?'float:right;width:100%;padding-left:8%;padding-right:8%':'float:left;margin-left:3%;width:100%;padding-left:8%;padding-right:8%'">
                            <div class="react-reveal"
                                 style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                <div class="style__SectionTitleStyled-d40vxv-0 kcvceY" :style="$i18n.locale == 'العربية' ?'float:right;margin-right:3%;width: 50%;':'float:left;margin-left:3%;width: 50%;'">
                                    <h2 v-if="pagedata" :style="$i18n.locale == 'العربية' ? 'text-align: right;font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'">
                                        {{
$i18n.locale == 'en' ? pagedata.page_entitle : $i18n.locale == 'العربية' ? pagedata.page_artitle : $i18n.locale == '中文' ? pagedata.page_chtitle :$i18n.locale=='Русский'?pagedata.page_rutitle: pagedata.page_frtitle
                                        }}</h2>
                                        <br />

<h3 v-if="pagedata" :style="$i18n.locale == 'العربية' ?'text-align: right;font-size: 23px!important;color:#ffffff;font-family: Cairo,sans-serif !important;margin-right:2%;':'font-size: 23px!important;color:#ffffff;font-family: Comfortaa!important;margin-left:2%'">
                                        {{
                                            $i18n.locale == 'en' ? pagedata.en_subtitle : $i18n.locale == 'العربية' ? pagedata.ar_subtitle : $i18n.locale == '中文' ? pagedata.ch_subtitle :$i18n.locale=='Русский'?pagedata.ru_subtitle: pagedata.fr_subtitle
                                        }}</h3>
                                </div>
                            </div>
                                                       <div class="btn_wrap" :style="$i18n.locale == 'العربية' ?'width:100%;float:right!important;margin-right:3%!important':'width:100%;float:left;margin-left:3%!important'">

                                <div class="react-reveal" :style="$i18n.locale == 'العربية' ?'float:right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg" style="width: 100%!important;text-align: center!important;"><a style=""
                                        href="https://marketequityinc.com/custom/demoaccountlinks.php" target="_blank"
                                        rel="noopener noreferrer"><span>
                                        {{
                                         $i18n.locale == 'en' ? 'Open Demo Account' : $i18n.locale == 'العربية' ? 'فتح حساب تجريبي' : $i18n.locale == '中文' ? '开设模拟账户':$i18n.locale=='Русский'?'Открыть демо-аккаунт' : 'Ouvrir un compte Dé'

                                        }}

                                        </span></a></div>
                                </div>
                                 <div class="react-reveal" :style="$i18n.locale == 'العربية' ?'float:right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg" style="width: 100%!important;text-align: center!important;"><a style=""
                                        href="https://marketequityinc.com/custom/liveaccountlinks.php" target="_blank"
                                        rel="noopener noreferrer"><span>
                                            {{
                                            $i18n.locale == 'en' ? 'Open Live Account' : $i18n.locale == 'العربية' ? 'فتح حساب حقيقي' : $i18n.locale == '中文' ? '开设真实账户':$i18n.locale=='Русский'?'Открыть реальный аккаунт': 'Ouvrir un compte Réel'
                                }}
                                        </span></a></div>
                                </div>
                                <div v-if="pagedata.layout==4" class="react-reveal"
                                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 360ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg"><a class="no-border"
                                                                                      href="https://www.linkedin.com/company/market-equity-inc/?originalSubdomain=in"
                                                                                      target="_blank"
                                                                                      rel="noopener noreferrer">
                                        <div class=" gatsby-image-wrapper"
                                             style="position: relative; overflow: hidden; display: inline-block; width: 100px; height: 30px;">
                                            <picture><img loading="lazy" width="100" height="30"
                                                          src="https://dev.marketequityinc.com/public/public/follow-linkedin.jpg"
                                                          alt="Follow us on Linked In"
                                                          style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                            </picture>
                                        </div>
                                    </a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section

                     :class="$i18n.locale=='العربية'?'FrameWork__InnerPageStyled-v8gq48-0 kVMyZl':'FrameWork__InnerPageStyled-v8gq48-0 fHTiUO'">                <div class="style__Details-drs3na-1 kMaaBC" >
                    <div class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo" :style="$i18n.locale == 'العربية' ? 'font-family:GE SS Two Medium !important;' :'font-family: Comfortaa!important;'">

                          <div  class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo"
                     :style="$i18n.locale == 'العربية' ? 'text-align: right;font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'">

 <div  class="row" style="padding-top: 5px;
padding-bottom: 55px;padding-right: 5%;padding-left: 5%;">                        <div class="FrameWork__Row-v8gq48-2 VIUMD"
                             style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                            <div style="padding-left:10%;padding-right:10%;padding-bottom:2%" v-html="$i18n.locale == 'en' ? pagedata.pagecontenten : $i18n.locale == 'العربية' ? pagedata.pagecontentar : $i18n.locale == '中文' ? pagedata.pagecontentch:$i18n.locale=='Русский'?pagedata.pagecontentru : pagedata.pagecontentfr
" class="FrameWork__ColSm-v8gq48-3 dIoETn">


                              {{
                                    $i18n.locale == 'en' ? pagedata.pagecontenten : $i18n.locale == 'العربية' ? pagedata.pagecontentar : $i18n.locale == '中文' ? pagedata.pagecontentch:$i18n.locale=='Русский'?pagedata.pagecontentru : pagedata.pagecontentfr
                                }}



                            </div>
                             <div class="col-md-12" :style="$i18n.locale == 'العربية' ? 'right:0;float:right;padding-right:10%;padding-top:-2%!important;' :'float:left;padding-left:10%;left:0;;padding-top:-1%!important;'">

 <p style="margin-left:-1%!important;margin-top: -4%!important;" v-if="$i18n.locale == 'العربية'"><strong style="font-weight: 800;">يرجى اتباع هذه الخطوات للتسجيل:</strong></p>
    <p style="margin-left:-1%!important;margin-top: -4%!important;" v-if="$i18n.locale == 'Français'"><strong style="font-weight: 800;">Veuillez suivre ces &eacute;tapes pour vous inscrire :</strong></p>
  <p style="margin-left:-1%!important;margin-top: -4%!important;" v-if="$i18n.locale == 'en'"><strong style="font-weight: 800;">Please follow these steps to register:</strong></p>

<div class="div-only-mobile">
<div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel" style="margin-top:2%!important;">
     <ol class="carousel-indicators">
    <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
  </ol>
  <div class="carousel-inner" style="height: auto !important;background-color:#ffffff!important;">
    <div class="carousel-item active" style="background-color:#ffffff!important;">
<div class="col-xs-12 ">
          <a @click="show1 = !show1">

<p style="text-align:center;;width:100%"><img alt="" src="https://devbackup.marketequityinc.com/public/public/199/20210930115300linkrefer.png" style="width: 126px; height: 103px;" /></p>
 </a>
 <p style="text-align:center;width:100%" v-if="$i18n.locale == 'العربية'">قم بتسجيل بياناتك وبيانات الشخص المعني للحصول على الرابط</p>
<p style="text-align:center;width:100%" v-if="$i18n.locale =='Français'">Enregistrez vos données et les données de la personne concernée pour obtenir le lien.</p>

<p style="text-align:center;width:100%" v-if="$i18n.locale == 'en' || $i18n.locale == '中文' ||  $i18n.locale == 'Русский'">Register your data and the data of the concerned person to obtain the link.</p>
<div align="center" style="margin-left: 25%;margin-right: 25%;text-align:center!important;width:100%" v-if="$i18n.locale == 'العربية'">
    <button @click="show1 = !show1" type="button" class="style__ButtonWrap-sc-1i4p4w8-0 UOTGs"><span class="caption"> إضغط هنا </span></button>
    </div>

<div align="center" style="margin-left: 25%;margin-right: 25%;text-align:center!important;width:100%" v-if="$i18n.locale == 'en' || $i18n.locale == '中文' ||  $i18n.locale == 'Русский'">
    <button @click="show1 = !show1" type="button" class="style__ButtonWrap-sc-1i4p4w8-0 UOTGs"><span class="caption"> Click Here </span></button>
    </div>
</div>
</div>
    <div class="carousel-item" style="height: auto !important;background-color:#ffffff!important;">
     <div class="col-xs-12">
<p style="text-align:center;width:100%"><img alt="" src="https://devbackup.marketequityinc.com/public/public/201/20210930120028sent2link.png" style="width: 126px; height: 103px;" /></p>
 <p style="text-align:center;width:100%" v-if="$i18n.locale == 'العربية'">سوف يتم إرسال رابط خاص بك من القسم المختص</p>
    <p style="text-align:center;width:100%" v-else-if="$i18n.locale =='Français'">vous allez recevoir un lien de la part du service commercial</p>


<p style="text-align:center;width:100%" v-if="$i18n.locale == 'en' || $i18n.locale == '中文' ||  $i18n.locale == 'Русский'">You will receive a link from the business development department.</p>
</div>
    </div>
    <div class="carousel-item" style="height: auto !important;background-color:#ffffff!important;">
<div class="col-xs-12">
              <a @click="show = !show">

<p style="text-align:center;width:100%"><img alt="" src="https://devbackup.marketequityinc.com/public/public/202/20210930120635verification.png" style="width: 126px; height: 103px;" /></p>
</a>
<p style="text-align:center;width:100%" v-if="$i18n.locale == 'العربية'">مثال توضيحي لكيفية حساب العوائد</p>
    <p style="text-align:center;width:100%" v-else-if="$i18n.locale =='Français'">ci dessous un exemple comment vous pouvez calculer vos revenus</p>

<p style="text-align:center;width:100%" v-if="$i18n.locale == 'en' || $i18n.locale == '中文' ||  $i18n.locale == 'Русский'" >Here is an example of the referral revenue calculation.</p>


<div align="center" style="margin-left: 25%;margin-right: 25%;text-align:center!important;width:100%" v-if="$i18n.locale == 'en' || $i18n.locale == '中文' ||  $i18n.locale == 'Русский' || $i18n.locale =='Français'">
    <button @click="show = !show" type="button" class="style__ButtonWrap-sc-1i4p4w8-0 UOTGs"><span class="caption"> Click Here </span></button>
    </div>
<div align="center" style="margin-left: 25%;margin-right: 25%;text-align:center!important;width:100%" v-if="$i18n.locale == 'العربية'">
<button @click="show = !show" type="button" class="style__ButtonWrap-sc-1i4p4w8-0 UOTGs"><span class="caption"> إضغط هنا </span></button></div>
</div>    </div>
  </div>
</div>
</div>


   <div class="desk" style="height: auto !important;">

<div class="row" style="height: auto !important;">

<div class="col-xs-4 ">
          <a @click="show1 = !show1">

<p style="text-align:center;;width:50%"><img alt="" src="https://devbackup.marketequityinc.com/public/public/199/20210930115300linkrefer.png" style="width: 126px; height: 103px;" /></p>
 </a>
</div>


<div class="col-xs-4">
<p style="text-align:center;width:50%"><img alt="" src="https://devbackup.marketequityinc.com/public/public/201/20210930120028sent2link.png" style="width: 126px; height: 103px;" /></p>
</div>

<div class="col-xs-4">
              <a @click="show = !show">

<p style="text-align:center;width:50%"><img alt="" src="https://devbackup.marketequityinc.com/public/public/202/20210930120635verification.png" style="width: 126px; height: 103px;" /></p>
</a>
</div>
</div>


<div class="row" style="margin-bottom:5%!important;">
<div class="col-xs-4 " style="text-align:center;">
<p style="text-align:center;width:50%" v-if="$i18n.locale == 'العربية'">قم بتسجيل بياناتك وبيانات الشخص المعني للحصول على الرابط</p>
<p style="text-align:center;width:50%" v-if="$i18n.locale =='Français'">Enregistrez vos données et les données de la personne concernée pour obtenir le lien.</p>

<p style="text-align:center;width:50%" v-if="$i18n.locale == 'en' || $i18n.locale == '中文' ||  $i18n.locale == 'Русский'">Register your data and the data of the concerned person to obtain the link.</p>
<p style="text-align:center;width:50%" v-if="$i18n.locale == 'العربية'"><button @click="show1 = !show1" type="button" class="style__ButtonWrap-sc-1i4p4w8-0 UOTGs"><span class="caption"> إضغط هنا </span></button></p>

<p style="text-align:center;width:50%" v-if="$i18n.locale == 'en' || $i18n.locale == '中文' ||  $i18n.locale == 'Русский' || $i18n.locale =='Français'"><button @click="show1 = !show1" type="button" class="style__ButtonWrap-sc-1i4p4w8-0 UOTGs"><span class="caption"> Click Here </span></button></p>

</div>

<div class="col-xs-4" style="text-align:center;">
    <p style="text-align:center;width:50%" v-if="$i18n.locale == 'العربية'">سوف يتم إرسال رابط خاص بك من القسم المختص</p>
    <p style="text-align:center;width:50%" v-else-if="$i18n.locale =='Français'">vous allez recevoir un lien de la part du service commercial</p>


<p style="text-align:center;width:50%" v-if="$i18n.locale == 'en' || $i18n.locale == '中文' ||  $i18n.locale == 'Русский'">You will receive a link from the business development department.</p>
</div>

<div class="col-xs-4" style="text-align:center;">
<p style="text-align:center;width:50%" v-if="$i18n.locale == 'العربية'">مثال توضيحي لكيفية حساب العوائد</p>
    <p style="text-align:center;width:50%" v-else-if="$i18n.locale =='Français'">ci dessous un exemple comment vous pouvez calculer vos revenus</p>

<p style="text-align:center;width:50%" v-if="$i18n.locale == 'en' || $i18n.locale == '中文' ||  $i18n.locale == 'Русский'" >Here is an example of the referral revenue calculation.</p>


<p style="text-align:center;width:50%" v-if="$i18n.locale == 'en' || $i18n.locale == '中文' ||  $i18n.locale == 'Русский' || $i18n.locale =='Français'"><button @click="show = !show" type="button" class="style__ButtonWrap-sc-1i4p4w8-0 UOTGs"><span class="caption"> Click Here </span></button></p>
<p style="text-align:center;width:50%" v-if="$i18n.locale == 'العربية'"><button @click="show = !show" type="button" class="style__ButtonWrap-sc-1i4p4w8-0 UOTGs"><span class="caption"> إضغط هنا </span></button></p>


</div>
</div>


</div>
</div>
 <transition name="slide-fade">
                                <div class="col-md-12" :style="$i18n.locale == 'العربية' ? 'right:0;float:right;padding-right:10%' :'left:0;float:left;padding-left:10%'">



    <div v-if="show" class="row">
        <div class="col-md-12 ">
            <p v-if="$i18n.locale == 'العربية'"><strong>على سبيل المثال</strong></p>
                                    <p v-else-if="$i18n.locale =='Français'"><strong>Par exemple</strong></p>


            <p v-if="$i18n.locale == 'en' || $i18n.locale == '中文' ||  $i18n.locale == 'Русский'"><strong>For Example</strong></p>

            </div>

    <div class="col-xs-12 col-md-6 ">
<table class="table" style="margin-top:1%;margin-bottom:1%;" v-if="$i18n.locale == 'العربية'">
	<thead>
		<tr>
			<th scope="col" style="text-align:center">عدد العقود</th>
			<th scope="col" style="text-align:center">المعدل</th>
			<th scope="col" style="text-align:center">المجموع</th>
		</tr>
	</thead>
	<tbody>
		<tr>
			<td style="text-align:center">100</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">200$</td>
		</tr>
		<tr>
			<td style="text-align:center">200</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">400$</td>
		</tr>
		<tr>
			<td style="text-align:center">300</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">600$</td>
		</tr>
		<tr>
			<td style="text-align:center">400</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">800$</td>
		</tr>
		<tr>
			<td style="text-align:center">500</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">1000$</td>
		</tr>
		<tr>
			<td style="text-align:center">600</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">1200$</td>
		</tr>
		<tr>
			<td style="text-align:center">700</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">1400$</td>
		</tr>
		<tr>
			<td style="text-align:center">800</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">1600$</td>
		</tr>
		<tr>
			<td style="text-align:center">900</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">1800$</td>
		</tr>
		<tr>
			<td style="text-align:center">1000</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">2000$</td>
		</tr>
			<tr>
			<td colspan="3" style="text-align:center">غير محدود


</td>

		</tr>
	</tbody>
</table>

<table class="table" v-else-if="$i18n.locale == 'Français'" style="margin-top:1%;margin-bottom:1%;" >
	<thead>
		<tr>
			<th scope="col" style="text-align:center">Nombre de lots</th>
			<th scope="col" style="text-align:center">Taux</th>
			<th scope="col" style="text-align:center">Total</th>
		</tr>
	</thead>
<tbody>
		<tr>
			<td style="text-align:center">100</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">200$</td>
		</tr>
		<tr>
			<td style="text-align:center">200</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">400$</td>
		</tr>
		<tr>
			<td style="text-align:center">300</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">600$</td>
		</tr>
		<tr>
			<td style="text-align:center">400</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">800$</td>
		</tr>
		<tr>
			<td style="text-align:center">500</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">1000$</td>
		</tr>
		<tr>
			<td style="text-align:center">600</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">1200$</td>
		</tr>
		<tr>
			<td style="text-align:center">700</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">1400$</td>
		</tr>
		<tr>
			<td style="text-align:center">800</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">1600$</td>
		</tr>
		<tr>
			<td style="text-align:center">900</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">1800$</td>
		</tr>
		<tr>
			<td style="text-align:center">1000</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">2000$</td>
		</tr>
		<tr>
			<td colspan="3" style="text-align:center">aucune limite</td>

		</tr>
	</tbody>
</table>


<table class="table" style="margin-top:1%;margin-bottom:1%;" v-else>
	<thead>
		<tr>
			<th scope="col" style="text-align:center">No of Lots</th>
			<th scope="col" style="text-align:center">Rate</th>
			<th scope="col" style="text-align:center">Total</th>
		</tr>
	</thead>
<tbody>
		<tr>
			<td style="text-align:center">100</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">200$</td>
		</tr>
		<tr>
			<td style="text-align:center">200</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">400$</td>
		</tr>
		<tr>
			<td style="text-align:center">300</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">600$</td>
		</tr>
		<tr>
			<td style="text-align:center">400</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">800$</td>
		</tr>
		<tr>
			<td style="text-align:center">500</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">1000$</td>
		</tr>
		<tr>
			<td style="text-align:center">600</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">1200$</td>
		</tr>
		<tr>
			<td style="text-align:center">700</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">1400$</td>
		</tr>
		<tr>
			<td style="text-align:center">800</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">1600$</td>
		</tr>
		<tr>
			<td style="text-align:center">900</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">1800$</td>
		</tr>
		<tr>
			<td style="text-align:center">1000</td>
			<td style="text-align:center">2$</td>
			<td style="text-align:center">2000$</td>
		</tr>
		<tr>
			<td colspan="3" style="text-align:center">No Limits</td>

		</tr>
	</tbody>
</table>

</div>

</div>
</div>

  </transition>

                        <transition name="slide-fade">
                                <div  v-if="show1" class="col-md-12" :style="$i18n.locale == 'العربية' ? 'right:0;float:right;padding-right:10%' :'left:0;'">
                            <div class="col-md-12" :style="$i18n.locale == 'العربية' ? 'right:0;float:right;padding-right:10%' :'left:0;'">


                                        <form :style="$i18n.locale == 'العربية' ? 'float: right;direction:rtl;text-align: right !important;padding-right:10%'
 :'float: left;direction:rtl;text-align: left !important;padding-left: 10%;'" class=" jZQfFQ">
                                            <hr class="solid" style="color:#404040!important;">
                                            <br />


                                            <h2 style="color:#1a859d">  {{
                                                            $i18n.locale == 'en' ? 'Refer A Friend' : $i18n.locale == 'العربية' ? ' شارك التداول مع أصدقائك ' : $i18n.locale == '中文' ? 'Refer A Friend' :$i18n.locale ==' Référez un ami'?'Français': 'Refer A Friend'
                                                            }}</h2>

                                                                    <h3 style="color:#1a859d;font-size: 22px!important;">  {{
                                                            $i18n.locale == 'en' ? 'Your Personal Data' : $i18n.locale == 'العربية' ? 'بياناتك الشخصية ' : $i18n.locale == '中文' ? 'Your Personal Data' : 'vos informations personnelles'
                                                            }}</h3>
                                            <table class="table">

                                                <tr>

                                                    <td style="border:0;padding-right:10px;">
                                                        <label :style="$i18n.locale == 'العربية' ? 'font-family:  Cairo!important;float: right;direction:rtl;right:0':'float: left;direction:ltr;left:0'">
                                                            {{
                                                                $i18n.locale == 'en' ? 'First Name' : $i18n.locale =='العربية'?'الإسم الأول' : $i18n.locale == '中文' ? '名字' : 'Nom'
                                                            }}
                                                        </label><div>
                                                        <input :style="$i18n.locale == 'العربية' ? 'width: 100%;height: 55px;margin: 0px auto;border: 2px black solid;border-radius: 10px;text-align: right !important;'
 :'width: 100%;height: 55px;margin: 0px auto;border: 2px black solid;border-radius: 10px;text-align: left !important;'" v-model="firstname" name="your_name" type="text" autocomplete="nope"
                                                               placeholder="First Name" value="">

                                                        <!--                                                <div class="error-message">Please enter your name</div>-->
                                                    </div></td></tr>



                                                      <tr>

                                                    <td style="border:0;padding-right:10px;">
                                                        <label :style="$i18n.locale == 'العربية' ? 'font-family:  Cairo!important;float: right;direction:rtl;right:0':'float: left;direction:ltr;left:0'">
                                                             {{
                                                                $i18n.locale == 'en' ? 'Last Name' : $i18n.locale =='العربية'?'الإسم الأخير' : $i18n.locale == '中文' ? '名字' : 'prénom'
                                                            }}
                                                        </label><div>
                                                        <input :style="$i18n.locale == 'العربية' ? 'width: 100%;height: 55px;margin: 0px auto;border: 2px black solid;border-radius: 10px;text-align: right !important;'
 :'width: 100%;height: 55px;margin: 0px auto;border: 2px black solid;border-radius: 10px;text-align: left !important;'" v-model="lastname" name="your_name" type="text" autocomplete="nope"
                                                               placeholder="Last Name" value="">

                                                        <!--                                                <div class="error-message">Please enter your name</div>-->
                                                    </div></td></tr>


                                                <tr>
                                                    <td style="border:0">
                                                        <label :style="$i18n.locale == 'العربية' ? 'float: right;direction:rtl;right:0;font-family:  Cairo!important':'float: left;direction:ltr;left:0'">
                                                            {{
                                                                $i18n.locale == 'en' ? 'Email' : $i18n.locale == 'العربية' ? 'البريد الإلكتروني' : $i18n.locale == '中文' ? '邮箱' : 'Adresse email'
                                                            }}
                                                        </label><div >

                                                        <input :style="$i18n.locale == 'العربية' ? 'width: 100%;height: 55px;margin: 0px auto;border: 2px black solid;border-radius: 10px;text-align: right !important;'
 :'width: 100%;height: 55px;margin: 0px auto;border: 2px black solid;border-radius: 10px;text-align: left !important;'" v-model="email" name="email"  type="email" autocomplete="nope"
                                                                                       placeholder="Email" value="">

                                                    </div></td>
                                                </tr>



                                            <tr>
                                                <td style="border:0">
                                                    <label :style="$i18n.locale == 'العربية' ? 'float: right;direction:rtl;right:0;font-family:  Cairo!important':'float: left;direction:ltr;left:0'">
                                                        {{
                                                            $i18n.locale == 'en' ? 'Country' : $i18n.locale == 'العربية' ?'الدولة' : $i18n.locale == '中文' ? '邮箱' : 'Country'
                                                        }}
                                                    </label>
                                            <div class="SelectField"><div class="CustomSelectInput" >


                                                <select v-model="country" style="width: 100%;
height: 55px;
margin: 0px auto;
border: 2px black solid;
border-radius: 10px;"

                                                        :class="$i18n.locale=='العربية'?'form-control rtlclass':'form-control ltrclass'"
                                                        id="countries" @change="onChange($event)">


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="KW" value="965">
                                                        {{ $i18n.locale == 'العربية' ? 'الكويت' : 'Kuwait' }}
                                                    </option>
                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DZ" value="213">
                                                        {{ $i18n.locale == 'العربية' ? 'الجزائر' : 'Algeria' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AD" value="376">
                                                        {{ $i18n.locale == 'العربية' ? 'أندورا' : 'Andorra' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AI" value="1264">
                                                        {{ $i18n.locale == 'العربية' ? 'أنجويلا' : 'Anguilla' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AG" value="1268">{{
                                                            $i18n.locale == 'العربية' ? 'أنتيغوا وباربودا' : 'Antigua &amp; Barbuda'
                                                        }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AR" value="54">
                                                        {{ $i18n.locale == 'العربية' ? 'الأرجنتين' : 'Argentina' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AM" value="374">
                                                        {{ $i18n.locale == 'العربية' ? 'أرمينيا' : 'Armenia' }}
                                                    </option>
                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AW" value="297">
                                                        {{ $i18n.locale == 'العربية' ? 'أرمينيا' : 'Aruba' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AU" value="61">
                                                        {{ $i18n.locale == 'العربية' ? 'أستراليا' : 'Australia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AT" value="43">
                                                        {{ $i18n.locale == 'العربية' ? 'النمسا' : 'Austria' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AZ" value="994">
                                                        {{ $i18n.locale == 'العربية' ? 'أذربيجان' : 'Azerbaijan' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BS" value="1242">
                                                        {{ $i18n.locale == 'العربية' ? 'باهاماس' : 'Bahamas' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BH" value="973">
                                                        {{ $i18n.locale == 'العربية' ? 'البحرين' : 'Bahrain' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BD" value="880">
                                                        {{ $i18n.locale == 'العربية' ? 'بنجلاديش' : 'Bangladesh' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BB" value="1246">
                                                        {{ $i18n.locale == 'العربية' ? 'باربادوس' : 'Barbados' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BY" value="375">
                                                        {{ $i18n.locale == 'العربية' ? 'بيلاروس' : 'Belarus' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BE" value="32">
                                                        {{ $i18n.locale == 'العربية' ? 'بلجيكا' : 'Belgium' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BZ" value="501">
                                                        {{ $i18n.locale == 'العربية' ? 'بيليز' : 'Belize' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BJ" value="229">
                                                        {{ $i18n.locale == 'العربية' ? 'بنين' : 'Benin' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DZ" value="1441">
                                                        {{ $i18n.locale == 'العربية' ? 'برمودا' : 'Bermuda' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="975" value="975">
                                                        {{ $i18n.locale == 'العربية' ? 'بوتان' : 'Bhutan' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BO" value="591">
                                                        {{ $i18n.locale == 'العربية' ? 'بوليفيا' : 'Bolivia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DZ" value="213">{{
                                                            $i18n.locale == 'العربية' ? 'البوسنة والهرسك' : 'Bosnia Herzegovina'
                                                        }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BW" value="267">
                                                        {{ $i18n.locale == 'العربية' ? 'بوتسوانا' : 'Botswana' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BR" value="55">
                                                        {{ $i18n.locale == 'العربية' ? 'البرازيل' : 'Brazil' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DZ" value="213">
                                                        {{ $i18n.locale == 'العربية' ? 'بروناي' : 'Brunei' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BG" value="359">
                                                        {{ $i18n.locale == 'العربية' ? 'بلغاريا' : 'Bulgaria' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DZ" value="213">
                                                        {{ $i18n.locale == 'العربية' ? 'بوركينا فاسو ' : 'Burkina Faso' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BI" value="257">
                                                        {{ $i18n.locale == 'العربية' ? 'بوروندي' : 'Burundi' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="KH" value="855">
                                                        {{ $i18n.locale == 'العربية' ? 'بوروندي' : 'Cambodia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CM" value="237">
                                                        {{ $i18n.locale == 'العربية' ? 'كاميرون' : 'Cameroon' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CA" value="1">
                                                        {{ $i18n.locale == 'العربية' ? 'كندا' : 'Canada' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DZ" value="238">{{
                                                            $i18n.locale == 'العربية' ? 'الرأس الأخضر' : 'Cape Verde Islands'
                                                        }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DZ" value="1345">
                                                        {{ $i18n.locale == 'العربية' ? 'جزر كايمان' : 'Cayman Islands' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CF" value="236">{{
                                                            $i18n.locale == 'العربية' ? 'جمهورية أفريقيا الوسطى' : 'Central African Republic'
                                                        }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CL" value="56">
                                                        {{ $i18n.locale == 'العربية' ? 'تشيلي' : 'Chile' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CN" value="86">
                                                        {{ $i18n.locale == 'العربية' ? 'الصين' : 'China' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CO" value="57">
                                                        {{ $i18n.locale == 'العربية' ? 'كولومبيا' : 'Colombia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="KM" value="269">
                                                        {{ $i18n.locale == 'العربية' ? 'جزر القمر' : 'Comoros' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DZ" value="242">
                                                        {{ $i18n.locale == 'العربية' ? 'جمهورية الكونغو' : 'Congo' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CK" value="682">
                                                        {{ $i18n.locale == 'العربية' ? 'جزر كوك' : 'Cook Islands' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CR" value="506">
                                                        {{ $i18n.locale == 'العربية' ? 'كوستاريكا' : 'Costa Rica' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="HR" value="385">
                                                        {{ $i18n.locale == 'العربية' ? 'كرواتيا' : 'Croatia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CU" value="53">
                                                        {{ $i18n.locale == 'العربية' ? 'كوبا' : 'Cuba' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CY" value="90392">
                                                        {{ $i18n.locale == 'العربية' ? 'قبرص' : 'Cyprus North' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CZ" value="42">{{
                                                            $i18n.locale == 'العربية' ? 'جمهورية التشيك' : 'Czech Republic'
                                                        }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DK" value="45">
                                                        {{ $i18n.locale == 'العربية' ? 'الدنمارك' : 'Denmark' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DJ" value="253">
                                                        {{ $i18n.locale == 'العربية' ? 'جيبوتي' : 'Djibouti' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DM" value="1809">
                                                        {{ $i18n.locale == 'العربية' ? 'دومينيكا' : 'Dominica' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DO" value="1809">{{
                                                            $i18n.locale == 'العربية' ? 'جمهورية الدومينيكان' : 'Dominican Republic'
                                                        }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="EC" value="593">
                                                        {{ $i18n.locale == 'العربية' ? 'الإكوادور' : 'Ecuador' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="EG" value="20">
                                                        {{ $i18n.locale == 'العربية' ? 'مصر' : 'Egypt' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SV" value="213">
                                                        {{ $i18n.locale == 'العربية' ? 'السلفادور' : 'El Salvador' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GQ" value="240">{{
                                                            $i18n.locale == 'العربية' ? 'غينيا الاستوائية ' : 'Equatorial Guinea'
                                                        }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="ER" value="213">
                                                        {{ $i18n.locale == 'العربية' ? 'إريتريا' : 'Eritrea' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="EE" value="372">
                                                        {{ $i18n.locale == 'العربية' ? 'إستونيا' : 'Estonia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="ET" value="251">
                                                        {{ $i18n.locale == 'العربية' ? 'إثيوبيا' : 'Ethiopia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="FK" value="500">
                                                        {{ $i18n.locale == 'العربية' ? 'جزر فوكلاند' : 'Falkland Islands' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="FO" value="298">
                                                        {{ $i18n.locale == 'العربية' ? 'جزر فارو' : 'Faroe Islands' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="FJ" value="679">
                                                        {{ $i18n.locale == 'العربية' ? 'فيجي' : 'Fiji' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="FI" value="358">
                                                        {{ $i18n.locale == 'العربية' ? 'فنلندا' : 'Finland' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="FR" value="33">
                                                        {{ $i18n.locale == 'العربية' ? 'فرنسا' : 'France' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GF" value="594">
                                                        {{ $i18n.locale == 'العربية' ? 'غينيا الفرنسية' : 'French Guiana' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PF" value="689">{{
                                                            $i18n.locale == 'العربية' ? 'بولينيزيا الفرنسية' : 'French Polynesia'
                                                        }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GA" value="241">
                                                        {{ $i18n.locale == 'العربية' ? 'الغابون' : 'Gabon' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GM" value="220">
                                                        {{ $i18n.locale == 'العربية' ? 'غامبيا' : 'Gambia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GE" value="7880">
                                                        {{ $i18n.locale == 'العربية' ? 'جورجيا' : 'Georgia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DE" value="49">
                                                        {{ $i18n.locale == 'العربية' ? 'ألمانيا' : 'Germany' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GH" value="233">
                                                        {{ $i18n.locale == 'العربية' ? 'غانا' : 'Ghana' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GR" value="30">
                                                        {{ $i18n.locale == 'العربية' ? 'اليونان' : 'Greece' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GL" value="299">
                                                        {{ $i18n.locale == 'العربية' ? 'جرينلاند' : 'Greenland' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GD" value="1473">
                                                        {{ $i18n.locale == 'العربية' ? 'غرينادا' : 'Grenada' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GP" value="590">
                                                        {{ $i18n.locale == 'العربية' ? 'غوادلوب' : 'Guadeloupe' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GU" value="671">
                                                        {{ $i18n.locale == 'العربية' ? 'غوام' : 'Guam' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DZ" value="502">
                                                        {{ $i18n.locale == 'العربية' ? 'غواتيمال' : 'Guatemala' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GN" value="224">
                                                        {{ $i18n.locale == 'العربية' ? 'غينيا' : 'Guinea' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GW" value="245">
                                                        {{ $i18n.locale == 'العربية' ? 'غينيا بيساو' : 'Guinea - Bissau' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GY" value="592">
                                                        {{ $i18n.locale == 'العربية' ? 'غيانا' : 'Guyana' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="HT" value="509">
                                                        {{ $i18n.locale == 'العربية' ? 'هايتي' : 'Haiti' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="HN" value="504">
                                                        {{ $i18n.locale == 'العربية' ? 'هندوراس' : 'Honduras' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="HK" value="852">
                                                        {{ $i18n.locale == 'العربية' ? 'هونج كونج' : 'Hong Kong' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="HU" value="36">
                                                        {{ $i18n.locale == 'العربية' ? 'المجر' : 'Hungary' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="IS" value="354">
                                                        {{ $i18n.locale == 'العربية' ? 'أيسلندا' : 'Iceland' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="IN" value="91">
                                                        {{ $i18n.locale == 'العربية' ? 'الهند' : 'India' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="ID" value="62">
                                                        {{ $i18n.locale == 'العربية' ? 'اندونيسيا' : 'Indonesia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="IR" value="98">
                                                        {{ $i18n.locale == 'العربية' ? 'ايران' : 'Iran' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="IQ" value="964">
                                                        {{ $i18n.locale == 'العربية' ? 'العراق' : 'Iraq' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="IE" value="353">
                                                        {{ $i18n.locale == 'العربية' ? 'جمهورية أيرلندا ' : 'Ireland' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="IL" value="972">
                                                        {{ $i18n.locale == 'العربية' ? 'إسرائيل' : 'Israel' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="IT" value="39">
                                                        {{ $i18n.locale == 'العربية' ? 'إيطاليا' : 'Italy' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="JM" value="1876">
                                                        {{ $i18n.locale == 'العربية' ? 'جامايكا' : 'Jamaica' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="JP" value="81">
                                                        {{ $i18n.locale == 'العربية' ? 'اليابان' : 'Japan' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="JO" value="962">
                                                        {{ $i18n.locale == 'العربية' ? 'الأردن' : 'Jordan' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="KZ" value="7">
                                                        {{ $i18n.locale == 'العربية' ? 'كازاخستان' : 'Kazakhstan' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="KE" value="254">
                                                        {{ $i18n.locale == 'العربية' ? 'كينيا' : 'Kenya' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="KI" value="686">
                                                        {{ $i18n.locale == 'العربية' ? 'كيريباتي' : 'Kiribati' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="KP" value="850">
                                                        {{ $i18n.locale == 'العربية' ? 'كوريا الشمالية' : 'Korea North' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="KR" value="82">
                                                        {{ $i18n.locale == 'العربية' ? 'كوريا الجنوبية ' : 'Korea South' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="KG" value="996">
                                                        {{ $i18n.locale == 'العربية' ? 'قيرغيزستان' : 'Kyrgyzstan' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LA" value="856">
                                                        {{ $i18n.locale == 'العربية' ? 'لاوس' : 'Laos' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LV" value="371">
                                                        {{ $i18n.locale == 'العربية' ? 'لاتفيا' : 'Latvia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LB" value="961">
                                                        {{ $i18n.locale == 'العربية' ? 'لبنان' : 'Lebanon' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LS" value="266">
                                                        {{ $i18n.locale == 'العربية' ? 'ليسوتو' : 'Lesotho' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LR" value="231">
                                                        {{ $i18n.locale == 'العربية' ? 'ليبيريا' : 'Liberia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LY" value="218">
                                                        {{ $i18n.locale == 'العربية' ? 'ليبيا' : 'Libya' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LI" value="417">
                                                        {{ $i18n.locale == 'العربية' ? 'ليختنشتاين' : 'Liechtenstein' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LT" value="370">
                                                        {{ $i18n.locale == 'العربية' ? 'ليتوانيا' : 'Lithuania' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LU" value="352">
                                                        {{ $i18n.locale == 'العربية' ? 'لوكسمبورغ' : 'Luxembourg' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MK" value="389">
                                                        {{ $i18n.locale == 'العربية' ? 'مقدونيا الشمالية' : 'Macedonia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MG" value="261">
                                                        {{ $i18n.locale == 'العربية' ? 'مدغشقر' : 'Madagascar' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MW" value="265">
                                                        {{ $i18n.locale == 'العربية' ? 'مدغشقر' : 'Malawi' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MY" value="60">
                                                        {{ $i18n.locale == 'العربية' ? 'ماليزيا' : 'Malaysia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MV" value="960">
                                                        {{ $i18n.locale == 'العربية' ? 'المالديف' : 'Maldives' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="ML" value="223">
                                                        {{ $i18n.locale == 'العربية' ? 'مالي' : 'Mali' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MT" value="356">
                                                        {{ $i18n.locale == 'العربية' ? 'مالطا' : 'Malta' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MH" value="692">
                                                        {{ $i18n.locale == 'العربية' ? 'جزر مارشال' : 'Marshall Islands' }}
                                                    </option>
                                                    >

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MQ" value="596">
                                                        {{ $i18n.locale == 'العربية' ? 'مارتينيك' : 'Martinique' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MR" value="222">
                                                        {{ $i18n.locale == 'العربية' ? 'موريتانيا' : 'Mauritania' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="YT" value="269">
                                                        {{ $i18n.locale == 'العربية' ? 'مايوت' : 'Mayotte' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MX" value="52">
                                                        {{ $i18n.locale == 'العربية' ? 'المكسيك' : 'Mexico' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MD" value="373">
                                                        {{ $i18n.locale == 'العربية' ? 'مولدوفا' : 'Moldova' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MC" value="377">
                                                        {{ $i18n.locale == 'العربية' ? 'موناكو' : 'Monaco' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MN" value="976">
                                                        {{ $i18n.locale == 'العربية' ? 'منغوليا' : 'Mongolia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MS" value="1664">
                                                        {{ $i18n.locale == 'العربية' ? 'مونتسرات' : 'Montserrat' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MA" value="212">
                                                        {{ $i18n.locale == 'العربية' ? 'المغرب' : 'Morocco' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MZ" value="258">
                                                        {{ $i18n.locale == 'العربية' ? 'موزمبيق' : 'Mozambique' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MN" value="95">
                                                        {{ $i18n.locale == 'العربية' ? 'ميانمار' : 'Myanmar' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NA" value="264">
                                                        {{ $i18n.locale == 'العربية' ? 'ناميبيا' : 'Namibia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NR" value="674">
                                                        {{ $i18n.locale == 'العربية' ? 'ناورو' : 'Nauru' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NP" value="977">
                                                        {{ $i18n.locale == 'العربية' ? 'نيبال' : 'Nepal' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NL" value="31">
                                                        {{ $i18n.locale == 'العربية' ? 'هولندا' : 'Netherlands' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NC" value="687">{{
                                                            $i18n.locale == 'العربية' ? 'كاليدونيا الجديدة ' : 'New Caledonia'
                                                        }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NZ" value="64">
                                                        {{ $i18n.locale == 'العربية' ? 'نيوزيلندا' : 'New Zealand' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NI" value="505">
                                                        {{ $i18n.locale == 'العربية' ? 'نيكاراجوا' : 'Nicaragua' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NE" value="227">
                                                        {{ $i18n.locale == 'العربية' ? 'النيجر' : 'Niger' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NG" value="234">
                                                        {{ $i18n.locale == 'العربية' ? 'نيجيريا' : 'Nigeria' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NO" value="47">
                                                        {{ $i18n.locale == 'العربية' ? 'النرويج' : 'Norway' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="OM" value="968">
                                                        {{ $i18n.locale == 'العربية' ? 'عُمان' : 'Oman' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PW" value="680">
                                                        {{ $i18n.locale == 'العربية' ? 'بالاو' : 'Palau' }}
                                                    </option>
                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="IL" value="972">
                                                        {{ $i18n.locale == 'العربية' ? 'فلسطين' : 'Palestine' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PA" value="507">
                                                        {{ $i18n.locale == 'العربية' ? 'بنما' : 'Panama' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PG" value="675">{{
                                                            $i18n.locale == 'العربية' ? 'بابوا غينيا الجديدة' : 'Papua New Guinea'
                                                        }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PY" value="595">
                                                        {{ $i18n.locale == 'العربية' ? 'باراغواي' : 'Paraguay' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PE" value="51">
                                                        {{ $i18n.locale == 'العربية' ? 'بيرو' : 'Peru' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PH" value="63">
                                                        {{ $i18n.locale == 'العربية' ? 'الفلبين' : 'Philippines' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PL" value="48">
                                                        {{ $i18n.locale == 'العربية' ? 'بولندا' : 'Poland' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PT" value="351">
                                                        {{ $i18n.locale == 'العربية' ? 'البرتغال' : 'Portugal' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PR" value="1787">
                                                        {{ $i18n.locale == 'العربية' ? 'بورتوريكو' : 'Puerto Rico' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="QA" value="974">
                                                        {{ $i18n.locale == 'العربية' ? 'قطر' : 'Qatar' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="RE" value="262">
                                                        {{ $i18n.locale == 'العربية' ? 'ريونيون' : 'Reunion' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="RO" value="40">
                                                        {{ $i18n.locale == 'العربية' ? 'رومانيا' : 'Romania' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="RU" value="7">
                                                        {{ $i18n.locale == 'العربية' ? 'روسيا' : 'Russia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="RW" value="250">
                                                        {{ $i18n.locale == 'العربية' ? 'رواندا' : 'Rwanda' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SM" value="378">
                                                        {{ $i18n.locale == 'العربية' ? 'سان مارينو' : 'San Marino' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SA" value="966">
                                                        {{ $i18n.locale == 'العربية' ? 'السعودية' : 'Saudi Arabia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SN" value="221">
                                                        {{ $i18n.locale == 'العربية' ? 'السنغال' : 'Senegal' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CS" value="381">
                                                        {{ $i18n.locale == 'العربية' ? 'صربيا' : 'Serbia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SC" value="248">
                                                        {{ $i18n.locale == 'العربية' ? 'سيشل' : 'Seychelles' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SL" value="232">
                                                        {{ $i18n.locale == 'العربية' ? 'سيراليون' : 'Sierra Leone' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SG" value="65">
                                                        {{ $i18n.locale == 'العربية' ? 'سنغافورة' : 'Singapore' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SK" value="421">
                                                        {{ $i18n.locale == 'العربية' ? 'سلوفاكيا' : 'Slovak Republic' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SI" value="386">
                                                        {{ $i18n.locale == 'العربية' ? 'سلوفينيا' : 'Slovenia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SB" value="677">
                                                        {{ $i18n.locale == 'العربية' ? 'جزر سليمان' : 'Solomon Islands' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SO" value="252">
                                                        {{ $i18n.locale == 'العربية' ? 'الصومال' : 'Somalia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="ZA" value="27">
                                                        {{ $i18n.locale == 'العربية' ? 'جنوب أفريقيا' : 'South Africa' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="ES" value="34">
                                                        {{ $i18n.locale == 'العربية' ? 'إسبانيا' : 'Spain' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LK" value="94">
                                                        {{ $i18n.locale == 'العربية' ? 'سريلانكا' : 'Sri Lanka' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SD" value="249">
                                                        {{ $i18n.locale == 'العربية' ? 'السودان' : 'Sudan' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SR" value="597">
                                                        {{ $i18n.locale == 'العربية' ? 'سورينام' : 'Suriname' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SZ" value="268">{{
                                                            $i18n.locale == 'العربية' ? 'سوازيلند (إسواتيني) ' : 'Swaziland'
                                                        }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SE" value="46">
                                                        {{ $i18n.locale == 'العربية' ? 'السويد' : 'Sweden' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CH" value="41">
                                                        {{ $i18n.locale == 'العربية' ? 'سويسرا	' : 'Switzerland' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SI" value="963">
                                                        {{ $i18n.locale == 'العربية' ? 'سوريا' : 'Syria' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TW" value="886">
                                                        {{ $i18n.locale == 'العربية' ? 'تايوان' : 'Taiwan' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TH" value="66">
                                                        {{ $i18n.locale == 'العربية' ? 'تايلند' : 'Thailand' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TG" value="228">
                                                        {{ $i18n.locale == 'العربية' ? 'توغو' : 'Togo' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TO" value="676">
                                                        {{ $i18n.locale == 'العربية' ? 'تونغا' : 'Tonga' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TT" value="1868">{{
                                                            $i18n.locale == 'العربية' ? 'ترينيداد وتوباغو ' : 'Trinidad &amp; Tobago'
                                                        }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TN" value="216">
                                                        {{ $i18n.locale == 'العربية' ? 'تونس' : 'Tunisia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TR" value="90">
                                                        {{ $i18n.locale == 'العربية' ? 'تركيا' : 'Turkey' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TM" value="7">
                                                        {{ $i18n.locale == 'العربية' ? 'تركمانستان' : 'Turkmenistan' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TM" value="993">
                                                        {{ $i18n.locale == 'العربية' ? 'تركمانستان' : 'Turkmenistan' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TV" value="688">
                                                        {{ $i18n.locale == 'العربية' ? 'توفالو' : 'Tuvalu' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="UG" value="256">
                                                        {{ $i18n.locale == 'العربية' ? 'أوغندا' : 'Uganda' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="UA" value="380">
                                                        {{ $i18n.locale == 'العربية' ? 'أوكرانيا' : 'Ukraine' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AE" value="971">{{
                                                            $i18n.locale == 'العربية' ? 'الإمارات' : 'Unitied Arab Emirates'
                                                        }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="UY" value="598">
                                                        {{ $i18n.locale == 'العربية' ? 'أوروغواي' : 'Uruguay' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="UZ" value="7">
                                                        {{ $i18n.locale == 'العربية' ? 'أوزبكستان' : 'Uzbekistan' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="VU" value="678">
                                                        {{ $i18n.locale == 'العربية' ? 'فانواتو' : 'Vanuatu' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="VA" value="379">
                                                        {{ $i18n.locale == 'العربية' ? 'الفاتيكان' : 'Vatican City' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="VE" value="58">
                                                        {{ $i18n.locale == 'العربية' ? 'فنزويلا' : 'Venezuela' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="VN" value="84">
                                                        {{ $i18n.locale == 'العربية' ? 'فيتنام' : 'Vietnam' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="VG" value="84">{{
                                                            $i18n.locale == 'العربية' ? 'جزر العذراء البريطانية' : 'Virgin Islands - British'
                                                        }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="VI" value="84">{{
                                                            $i18n.locale == 'العربية' ? 'جزر العذراء الأمريكية' : 'Virgin Islands - US'
                                                        }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="WF" value="681">{{
                                                            $i18n.locale == 'العربية' ? 'واليس وفوتونا' : 'Wallis &amp; Futuna'
                                                        }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="YE" value="969">
                                                        {{ $i18n.locale == 'العربية' ? 'اليمن الشمال' : 'Yemen (North)' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="YE" value="967">
                                                        {{ $i18n.locale == 'العربية' ? 'اليمن الجنوب' : 'Yemen (South)' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="ZM" value="260">
                                                        {{ $i18n.locale == 'العربية' ? 'زامبيا' : 'Zambia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="ZW" value="263">
                                                        {{ $i18n.locale == 'العربية' ? 'زيمبابوي' : 'Zimbabwe' }}
                                                    </option>
                                                </select>



<!--                                                <label :style="$i18n.locale == 'العربية' ? 'font-family:  Cairo!important;float: right;direction:rtl;right:0;color: rgb(153, 153, 153);':'float: left;direction:ltr;left:0;color: rgb(153, 153, 153);'">-->
<!--                                                    {{-->
<!--                                                        $i18n.locale == 'en' ? 'Country' : $i18n.locale == 'العربية' ? 'موضوع' : $i18n.locale == '中文' ? '主题' : 'Sujet'-->
<!--                                                    }}-->

<!--                                                </label>-->
                                            </div></div>
                                                   </td>
                                            </tr>
                                                <tr>
                                                    <td style="border:0">
                                                        <label :style="$i18n.locale == 'العربية' ? 'font-family:  Cairo!important;float: right;direction:rtl;right:0':'float: left;direction:ltr;left:0'">
                                                            {{
                                                                $i18n.locale == 'en' ? 'Mobile' : $i18n.locale == 'العربية' ? 'رقم الهاتف' : $i18n.locale == '中文' ? '主题' : 'Sujet'
                                                            }}

                                                        </label>
                                                        <div><input :style="$i18n.locale == 'العربية' ? 'width: 100%;height: 55px;margin: 0px auto;border: 2px black solid;border-radius: 10px;text-align: right !important;'
 :'width: 100%;height: 55px;margin: 0px auto;border: 2px black solid;border-radius: 10px;text-align: left !important;'"  v-model="mobile" name="subject" type="text" autocomplete="nope"
                                                                    placeholder="Mobile" >
                                                           </div>
                                                    </td>
                                                </tr>
                                                <tr><td style="border-top: 0px!important">        <h3 style="color:#1a859d;font-size: 22px!important;">  {{
                                                            $i18n.locale == 'en' ? 'Your Referred Member Personal Data' : $i18n.locale == 'العربية' ? 'بيانات الشخص المدعو من جانبك ' : $i18n.locale == '中文' ? 'Your Referred Member Personal Data' : 'Informations personnelles de la personne invitée par vous'
                                                            }}</h3></td></tr>

                                                    <tr>

                                                    <td style="border:0;padding-right:10px;">
                                                        <label :style="$i18n.locale == 'العربية' ? 'font-family:  Cairo!important;float: right;direction:rtl;right:0':'float: left;direction:ltr;left:0'">
                                                            {{
                                                                $i18n.locale == 'en' ? 'Name' : $i18n.locale == 'العربية' ? 'الإسم' : $i18n.locale == '中文' ? '名字' : 'Nom'
                                                            }}
                                                        </label><div>
                                                        <input :style="$i18n.locale == 'العربية' ? 'width: 100%;height: 55px;margin: 0px auto;border: 2px black solid;border-radius: 10px;text-align: right !important;'
 :'width: 100%;height: 55px;margin: 0px auto;border: 2px black solid;border-radius: 10px;text-align: left !important;'" v-model="friendfirstname" name="your_name" type="text" autocomplete="nope"
                                                               placeholder="First Name" value="">

                                                        <!--                                                <div class="error-message">Please enter your name</div>-->
                                                    </div></td></tr>

                                                <tr>
                                                    <td style="border:0">
                                                        <label :style="$i18n.locale == 'العربية' ? 'float: right;direction:rtl;right:0;font-family:  Cairo!important':'float: left;direction:ltr;left:0'">
                                                            {{
                                                                $i18n.locale == 'en' ? 'Email' : $i18n.locale == 'العربية' ? 'البريد الإلكتروني' : $i18n.locale == '中文' ? '邮箱' : 'Adresse email'
                                                            }}
                                                        </label><div >

                                                        <input :style="$i18n.locale == 'العربية' ? 'width: 100%;height: 55px;margin: 0px auto;border: 2px black solid;border-radius: 10px;text-align: right !important;'
 :'width: 100%;height: 55px;margin: 0px auto;border: 2px black solid;border-radius: 10px;text-align: left !important;'" v-model="friendemail" name="email"  type="email" autocomplete="nope"
                                                                                       placeholder="Email" value="">

                                                    </div></td>
                                                </tr>



                                            <tr>
                                                <td style="border:0">
                                                    <label :style="$i18n.locale == 'العربية' ? 'float: right;direction:rtl;right:0;font-family:  Cairo!important':'float: left;direction:ltr;left:0'">
                                                        {{
                                                            $i18n.locale == 'en' ? 'Country' : $i18n.locale == 'العربية' ?'الدولة' : $i18n.locale == '中文' ? '邮箱' : 'Country'
                                                        }}
                                                    </label>
                                            <div class="SelectField"><div class="CustomSelectInput" >


                                                <select v-model="friendcountry" style="width: 100%;
height: 55px;
margin: 0px auto;
border: 2px black solid;
border-radius: 10px;"

                                                        :class="$i18n.locale=='العربية'?'form-control rtlclass':'form-control ltrclass'"
                                                        id="countries" @change="onChangefriend($event)">


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="KW" value="965">
                                                        {{ $i18n.locale == 'العربية' ? 'الكويت' : 'Kuwait' }}
                                                    </option>
                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DZ" value="213">
                                                        {{ $i18n.locale == 'العربية' ? 'الجزائر' : 'Algeria' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AD" value="376">
                                                        {{ $i18n.locale == 'العربية' ? 'أندورا' : 'Andorra' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AI" value="1264">
                                                        {{ $i18n.locale == 'العربية' ? 'أنجويلا' : 'Anguilla' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AG" value="1268">{{
                                                            $i18n.locale == 'العربية' ? 'أنتيغوا وباربودا' : 'Antigua &amp; Barbuda'
                                                        }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AR" value="54">
                                                        {{ $i18n.locale == 'العربية' ? 'الأرجنتين' : 'Argentina' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AM" value="374">
                                                        {{ $i18n.locale == 'العربية' ? 'أرمينيا' : 'Armenia' }}
                                                    </option>
                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AW" value="297">
                                                        {{ $i18n.locale == 'العربية' ? 'أرمينيا' : 'Aruba' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AU" value="61">
                                                        {{ $i18n.locale == 'العربية' ? 'أستراليا' : 'Australia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AT" value="43">
                                                        {{ $i18n.locale == 'العربية' ? 'النمسا' : 'Austria' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AZ" value="994">
                                                        {{ $i18n.locale == 'العربية' ? 'أذربيجان' : 'Azerbaijan' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BS" value="1242">
                                                        {{ $i18n.locale == 'العربية' ? 'باهاماس' : 'Bahamas' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BH" value="973">
                                                        {{ $i18n.locale == 'العربية' ? 'البحرين' : 'Bahrain' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BD" value="880">
                                                        {{ $i18n.locale == 'العربية' ? 'بنجلاديش' : 'Bangladesh' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BB" value="1246">
                                                        {{ $i18n.locale == 'العربية' ? 'باربادوس' : 'Barbados' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BY" value="375">
                                                        {{ $i18n.locale == 'العربية' ? 'بيلاروس' : 'Belarus' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BE" value="32">
                                                        {{ $i18n.locale == 'العربية' ? 'بلجيكا' : 'Belgium' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BZ" value="501">
                                                        {{ $i18n.locale == 'العربية' ? 'بيليز' : 'Belize' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BJ" value="229">
                                                        {{ $i18n.locale == 'العربية' ? 'بنين' : 'Benin' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DZ" value="1441">
                                                        {{ $i18n.locale == 'العربية' ? 'برمودا' : 'Bermuda' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="975" value="975">
                                                        {{ $i18n.locale == 'العربية' ? 'بوتان' : 'Bhutan' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BO" value="591">
                                                        {{ $i18n.locale == 'العربية' ? 'بوليفيا' : 'Bolivia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DZ" value="213">{{
                                                            $i18n.locale == 'العربية' ? 'البوسنة والهرسك' : 'Bosnia Herzegovina'
                                                        }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BW" value="267">
                                                        {{ $i18n.locale == 'العربية' ? 'بوتسوانا' : 'Botswana' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BR" value="55">
                                                        {{ $i18n.locale == 'العربية' ? 'البرازيل' : 'Brazil' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DZ" value="213">
                                                        {{ $i18n.locale == 'العربية' ? 'بروناي' : 'Brunei' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BG" value="359">
                                                        {{ $i18n.locale == 'العربية' ? 'بلغاريا' : 'Bulgaria' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DZ" value="213">
                                                        {{ $i18n.locale == 'العربية' ? 'بوركينا فاسو ' : 'Burkina Faso' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="BI" value="257">
                                                        {{ $i18n.locale == 'العربية' ? 'بوروندي' : 'Burundi' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="KH" value="855">
                                                        {{ $i18n.locale == 'العربية' ? 'بوروندي' : 'Cambodia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CM" value="237">
                                                        {{ $i18n.locale == 'العربية' ? 'كاميرون' : 'Cameroon' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CA" value="1">
                                                        {{ $i18n.locale == 'العربية' ? 'كندا' : 'Canada' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DZ" value="238">{{
                                                            $i18n.locale == 'العربية' ? 'الرأس الأخضر' : 'Cape Verde Islands'
                                                        }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DZ" value="1345">
                                                        {{ $i18n.locale == 'العربية' ? 'جزر كايمان' : 'Cayman Islands' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CF" value="236">{{
                                                            $i18n.locale == 'العربية' ? 'جمهورية أفريقيا الوسطى' : 'Central African Republic'
                                                        }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CL" value="56">
                                                        {{ $i18n.locale == 'العربية' ? 'تشيلي' : 'Chile' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CN" value="86">
                                                        {{ $i18n.locale == 'العربية' ? 'الصين' : 'China' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CO" value="57">
                                                        {{ $i18n.locale == 'العربية' ? 'كولومبيا' : 'Colombia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="KM" value="269">
                                                        {{ $i18n.locale == 'العربية' ? 'جزر القمر' : 'Comoros' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DZ" value="242">
                                                        {{ $i18n.locale == 'العربية' ? 'جمهورية الكونغو' : 'Congo' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CK" value="682">
                                                        {{ $i18n.locale == 'العربية' ? 'جزر كوك' : 'Cook Islands' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CR" value="506">
                                                        {{ $i18n.locale == 'العربية' ? 'كوستاريكا' : 'Costa Rica' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="HR" value="385">
                                                        {{ $i18n.locale == 'العربية' ? 'كرواتيا' : 'Croatia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CU" value="53">
                                                        {{ $i18n.locale == 'العربية' ? 'كوبا' : 'Cuba' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CY" value="90392">
                                                        {{ $i18n.locale == 'العربية' ? 'قبرص' : 'Cyprus North' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CZ" value="42">{{
                                                            $i18n.locale == 'العربية' ? 'جمهورية التشيك' : 'Czech Republic'
                                                        }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DK" value="45">
                                                        {{ $i18n.locale == 'العربية' ? 'الدنمارك' : 'Denmark' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DJ" value="253">
                                                        {{ $i18n.locale == 'العربية' ? 'جيبوتي' : 'Djibouti' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DM" value="1809">
                                                        {{ $i18n.locale == 'العربية' ? 'دومينيكا' : 'Dominica' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DO" value="1809">{{
                                                            $i18n.locale == 'العربية' ? 'جمهورية الدومينيكان' : 'Dominican Republic'
                                                        }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="EC" value="593">
                                                        {{ $i18n.locale == 'العربية' ? 'الإكوادور' : 'Ecuador' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="EG" value="20">
                                                        {{ $i18n.locale == 'العربية' ? 'مصر' : 'Egypt' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SV" value="213">
                                                        {{ $i18n.locale == 'العربية' ? 'السلفادور' : 'El Salvador' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GQ" value="240">{{
                                                            $i18n.locale == 'العربية' ? 'غينيا الاستوائية ' : 'Equatorial Guinea'
                                                        }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="ER" value="213">
                                                        {{ $i18n.locale == 'العربية' ? 'إريتريا' : 'Eritrea' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="EE" value="372">
                                                        {{ $i18n.locale == 'العربية' ? 'إستونيا' : 'Estonia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="ET" value="251">
                                                        {{ $i18n.locale == 'العربية' ? 'إثيوبيا' : 'Ethiopia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="FK" value="500">
                                                        {{ $i18n.locale == 'العربية' ? 'جزر فوكلاند' : 'Falkland Islands' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="FO" value="298">
                                                        {{ $i18n.locale == 'العربية' ? 'جزر فارو' : 'Faroe Islands' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="FJ" value="679">
                                                        {{ $i18n.locale == 'العربية' ? 'فيجي' : 'Fiji' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="FI" value="358">
                                                        {{ $i18n.locale == 'العربية' ? 'فنلندا' : 'Finland' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="FR" value="33">
                                                        {{ $i18n.locale == 'العربية' ? 'فرنسا' : 'France' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GF" value="594">
                                                        {{ $i18n.locale == 'العربية' ? 'غينيا الفرنسية' : 'French Guiana' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PF" value="689">{{
                                                            $i18n.locale == 'العربية' ? 'بولينيزيا الفرنسية' : 'French Polynesia'
                                                        }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GA" value="241">
                                                        {{ $i18n.locale == 'العربية' ? 'الغابون' : 'Gabon' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GM" value="220">
                                                        {{ $i18n.locale == 'العربية' ? 'غامبيا' : 'Gambia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GE" value="7880">
                                                        {{ $i18n.locale == 'العربية' ? 'جورجيا' : 'Georgia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DE" value="49">
                                                        {{ $i18n.locale == 'العربية' ? 'ألمانيا' : 'Germany' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GH" value="233">
                                                        {{ $i18n.locale == 'العربية' ? 'غانا' : 'Ghana' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GR" value="30">
                                                        {{ $i18n.locale == 'العربية' ? 'اليونان' : 'Greece' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GL" value="299">
                                                        {{ $i18n.locale == 'العربية' ? 'جرينلاند' : 'Greenland' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GD" value="1473">
                                                        {{ $i18n.locale == 'العربية' ? 'غرينادا' : 'Grenada' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GP" value="590">
                                                        {{ $i18n.locale == 'العربية' ? 'غوادلوب' : 'Guadeloupe' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GU" value="671">
                                                        {{ $i18n.locale == 'العربية' ? 'غوام' : 'Guam' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="DZ" value="502">
                                                        {{ $i18n.locale == 'العربية' ? 'غواتيمال' : 'Guatemala' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GN" value="224">
                                                        {{ $i18n.locale == 'العربية' ? 'غينيا' : 'Guinea' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GW" value="245">
                                                        {{ $i18n.locale == 'العربية' ? 'غينيا بيساو' : 'Guinea - Bissau' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="GY" value="592">
                                                        {{ $i18n.locale == 'العربية' ? 'غيانا' : 'Guyana' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="HT" value="509">
                                                        {{ $i18n.locale == 'العربية' ? 'هايتي' : 'Haiti' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="HN" value="504">
                                                        {{ $i18n.locale == 'العربية' ? 'هندوراس' : 'Honduras' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="HK" value="852">
                                                        {{ $i18n.locale == 'العربية' ? 'هونج كونج' : 'Hong Kong' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="HU" value="36">
                                                        {{ $i18n.locale == 'العربية' ? 'المجر' : 'Hungary' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="IS" value="354">
                                                        {{ $i18n.locale == 'العربية' ? 'أيسلندا' : 'Iceland' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="IN" value="91">
                                                        {{ $i18n.locale == 'العربية' ? 'الهند' : 'India' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="ID" value="62">
                                                        {{ $i18n.locale == 'العربية' ? 'اندونيسيا' : 'Indonesia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="IR" value="98">
                                                        {{ $i18n.locale == 'العربية' ? 'ايران' : 'Iran' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="IQ" value="964">
                                                        {{ $i18n.locale == 'العربية' ? 'العراق' : 'Iraq' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="IE" value="353">
                                                        {{ $i18n.locale == 'العربية' ? 'جمهورية أيرلندا ' : 'Ireland' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="IL" value="972">
                                                        {{ $i18n.locale == 'العربية' ? 'إسرائيل' : 'Israel' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="IT" value="39">
                                                        {{ $i18n.locale == 'العربية' ? 'إيطاليا' : 'Italy' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="JM" value="1876">
                                                        {{ $i18n.locale == 'العربية' ? 'جامايكا' : 'Jamaica' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="JP" value="81">
                                                        {{ $i18n.locale == 'العربية' ? 'اليابان' : 'Japan' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="JO" value="962">
                                                        {{ $i18n.locale == 'العربية' ? 'الأردن' : 'Jordan' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="KZ" value="7">
                                                        {{ $i18n.locale == 'العربية' ? 'كازاخستان' : 'Kazakhstan' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="KE" value="254">
                                                        {{ $i18n.locale == 'العربية' ? 'كينيا' : 'Kenya' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="KI" value="686">
                                                        {{ $i18n.locale == 'العربية' ? 'كيريباتي' : 'Kiribati' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="KP" value="850">
                                                        {{ $i18n.locale == 'العربية' ? 'كوريا الشمالية' : 'Korea North' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="KR" value="82">
                                                        {{ $i18n.locale == 'العربية' ? 'كوريا الجنوبية ' : 'Korea South' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="KG" value="996">
                                                        {{ $i18n.locale == 'العربية' ? 'قيرغيزستان' : 'Kyrgyzstan' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LA" value="856">
                                                        {{ $i18n.locale == 'العربية' ? 'لاوس' : 'Laos' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LV" value="371">
                                                        {{ $i18n.locale == 'العربية' ? 'لاتفيا' : 'Latvia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LB" value="961">
                                                        {{ $i18n.locale == 'العربية' ? 'لبنان' : 'Lebanon' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LS" value="266">
                                                        {{ $i18n.locale == 'العربية' ? 'ليسوتو' : 'Lesotho' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LR" value="231">
                                                        {{ $i18n.locale == 'العربية' ? 'ليبيريا' : 'Liberia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LY" value="218">
                                                        {{ $i18n.locale == 'العربية' ? 'ليبيا' : 'Libya' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LI" value="417">
                                                        {{ $i18n.locale == 'العربية' ? 'ليختنشتاين' : 'Liechtenstein' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LT" value="370">
                                                        {{ $i18n.locale == 'العربية' ? 'ليتوانيا' : 'Lithuania' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LU" value="352">
                                                        {{ $i18n.locale == 'العربية' ? 'لوكسمبورغ' : 'Luxembourg' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MK" value="389">
                                                        {{ $i18n.locale == 'العربية' ? 'مقدونيا الشمالية' : 'Macedonia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MG" value="261">
                                                        {{ $i18n.locale == 'العربية' ? 'مدغشقر' : 'Madagascar' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MW" value="265">
                                                        {{ $i18n.locale == 'العربية' ? 'مدغشقر' : 'Malawi' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MY" value="60">
                                                        {{ $i18n.locale == 'العربية' ? 'ماليزيا' : 'Malaysia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MV" value="960">
                                                        {{ $i18n.locale == 'العربية' ? 'المالديف' : 'Maldives' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="ML" value="223">
                                                        {{ $i18n.locale == 'العربية' ? 'مالي' : 'Mali' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MT" value="356">
                                                        {{ $i18n.locale == 'العربية' ? 'مالطا' : 'Malta' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MH" value="692">
                                                        {{ $i18n.locale == 'العربية' ? 'جزر مارشال' : 'Marshall Islands' }}
                                                    </option>
                                                    >

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MQ" value="596">
                                                        {{ $i18n.locale == 'العربية' ? 'مارتينيك' : 'Martinique' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MR" value="222">
                                                        {{ $i18n.locale == 'العربية' ? 'موريتانيا' : 'Mauritania' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="YT" value="269">
                                                        {{ $i18n.locale == 'العربية' ? 'مايوت' : 'Mayotte' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MX" value="52">
                                                        {{ $i18n.locale == 'العربية' ? 'المكسيك' : 'Mexico' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MD" value="373">
                                                        {{ $i18n.locale == 'العربية' ? 'مولدوفا' : 'Moldova' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MC" value="377">
                                                        {{ $i18n.locale == 'العربية' ? 'موناكو' : 'Monaco' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MN" value="976">
                                                        {{ $i18n.locale == 'العربية' ? 'منغوليا' : 'Mongolia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MS" value="1664">
                                                        {{ $i18n.locale == 'العربية' ? 'مونتسرات' : 'Montserrat' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MA" value="212">
                                                        {{ $i18n.locale == 'العربية' ? 'المغرب' : 'Morocco' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MZ" value="258">
                                                        {{ $i18n.locale == 'العربية' ? 'موزمبيق' : 'Mozambique' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="MN" value="95">
                                                        {{ $i18n.locale == 'العربية' ? 'ميانمار' : 'Myanmar' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NA" value="264">
                                                        {{ $i18n.locale == 'العربية' ? 'ناميبيا' : 'Namibia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NR" value="674">
                                                        {{ $i18n.locale == 'العربية' ? 'ناورو' : 'Nauru' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NP" value="977">
                                                        {{ $i18n.locale == 'العربية' ? 'نيبال' : 'Nepal' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NL" value="31">
                                                        {{ $i18n.locale == 'العربية' ? 'هولندا' : 'Netherlands' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NC" value="687">{{
                                                            $i18n.locale == 'العربية' ? 'كاليدونيا الجديدة ' : 'New Caledonia'
                                                        }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NZ" value="64">
                                                        {{ $i18n.locale == 'العربية' ? 'نيوزيلندا' : 'New Zealand' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NI" value="505">
                                                        {{ $i18n.locale == 'العربية' ? 'نيكاراجوا' : 'Nicaragua' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NE" value="227">
                                                        {{ $i18n.locale == 'العربية' ? 'النيجر' : 'Niger' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NG" value="234">
                                                        {{ $i18n.locale == 'العربية' ? 'نيجيريا' : 'Nigeria' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="NO" value="47">
                                                        {{ $i18n.locale == 'العربية' ? 'النرويج' : 'Norway' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="OM" value="968">
                                                        {{ $i18n.locale == 'العربية' ? 'عُمان' : 'Oman' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PW" value="680">
                                                        {{ $i18n.locale == 'العربية' ? 'بالاو' : 'Palau' }}
                                                    </option>
                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="IL" value="972">
                                                        {{ $i18n.locale == 'العربية' ? 'فلسطين' : 'Palestine' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PA" value="507">
                                                        {{ $i18n.locale == 'العربية' ? 'بنما' : 'Panama' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PG" value="675">{{
                                                            $i18n.locale == 'العربية' ? 'بابوا غينيا الجديدة' : 'Papua New Guinea'
                                                        }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PY" value="595">
                                                        {{ $i18n.locale == 'العربية' ? 'باراغواي' : 'Paraguay' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PE" value="51">
                                                        {{ $i18n.locale == 'العربية' ? 'بيرو' : 'Peru' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PH" value="63">
                                                        {{ $i18n.locale == 'العربية' ? 'الفلبين' : 'Philippines' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PL" value="48">
                                                        {{ $i18n.locale == 'العربية' ? 'بولندا' : 'Poland' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PT" value="351">
                                                        {{ $i18n.locale == 'العربية' ? 'البرتغال' : 'Portugal' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="PR" value="1787">
                                                        {{ $i18n.locale == 'العربية' ? 'بورتوريكو' : 'Puerto Rico' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="QA" value="974">
                                                        {{ $i18n.locale == 'العربية' ? 'قطر' : 'Qatar' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="RE" value="262">
                                                        {{ $i18n.locale == 'العربية' ? 'ريونيون' : 'Reunion' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="RO" value="40">
                                                        {{ $i18n.locale == 'العربية' ? 'رومانيا' : 'Romania' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="RU" value="7">
                                                        {{ $i18n.locale == 'العربية' ? 'روسيا' : 'Russia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="RW" value="250">
                                                        {{ $i18n.locale == 'العربية' ? 'رواندا' : 'Rwanda' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SM" value="378">
                                                        {{ $i18n.locale == 'العربية' ? 'سان مارينو' : 'San Marino' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SA" value="966">
                                                        {{ $i18n.locale == 'العربية' ? 'السعودية' : 'Saudi Arabia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SN" value="221">
                                                        {{ $i18n.locale == 'العربية' ? 'السنغال' : 'Senegal' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CS" value="381">
                                                        {{ $i18n.locale == 'العربية' ? 'صربيا' : 'Serbia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SC" value="248">
                                                        {{ $i18n.locale == 'العربية' ? 'سيشل' : 'Seychelles' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SL" value="232">
                                                        {{ $i18n.locale == 'العربية' ? 'سيراليون' : 'Sierra Leone' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SG" value="65">
                                                        {{ $i18n.locale == 'العربية' ? 'سنغافورة' : 'Singapore' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SK" value="421">
                                                        {{ $i18n.locale == 'العربية' ? 'سلوفاكيا' : 'Slovak Republic' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SI" value="386">
                                                        {{ $i18n.locale == 'العربية' ? 'سلوفينيا' : 'Slovenia' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SB" value="677">
                                                        {{ $i18n.locale == 'العربية' ? 'جزر سليمان' : 'Solomon Islands' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SO" value="252">
                                                        {{ $i18n.locale == 'العربية' ? 'الصومال' : 'Somalia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="ZA" value="27">
                                                        {{ $i18n.locale == 'العربية' ? 'جنوب أفريقيا' : 'South Africa' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="ES" value="34">
                                                        {{ $i18n.locale == 'العربية' ? 'إسبانيا' : 'Spain' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="LK" value="94">
                                                        {{ $i18n.locale == 'العربية' ? 'سريلانكا' : 'Sri Lanka' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SD" value="249">
                                                        {{ $i18n.locale == 'العربية' ? 'السودان' : 'Sudan' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SR" value="597">
                                                        {{ $i18n.locale == 'العربية' ? 'سورينام' : 'Suriname' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SZ" value="268">{{
                                                            $i18n.locale == 'العربية' ? 'سوازيلند (إسواتيني) ' : 'Swaziland'
                                                        }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SE" value="46">
                                                        {{ $i18n.locale == 'العربية' ? 'السويد' : 'Sweden' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="CH" value="41">
                                                        {{ $i18n.locale == 'العربية' ? 'سويسرا	' : 'Switzerland' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="SI" value="963">
                                                        {{ $i18n.locale == 'العربية' ? 'سوريا' : 'Syria' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TW" value="886">
                                                        {{ $i18n.locale == 'العربية' ? 'تايوان' : 'Taiwan' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TH" value="66">
                                                        {{ $i18n.locale == 'العربية' ? 'تايلند' : 'Thailand' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TG" value="228">
                                                        {{ $i18n.locale == 'العربية' ? 'توغو' : 'Togo' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TO" value="676">
                                                        {{ $i18n.locale == 'العربية' ? 'تونغا' : 'Tonga' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TT" value="1868">{{
                                                            $i18n.locale == 'العربية' ? 'ترينيداد وتوباغو ' : 'Trinidad &amp; Tobago'
                                                        }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TN" value="216">
                                                        {{ $i18n.locale == 'العربية' ? 'تونس' : 'Tunisia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TR" value="90">
                                                        {{ $i18n.locale == 'العربية' ? 'تركيا' : 'Turkey' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TM" value="7">
                                                        {{ $i18n.locale == 'العربية' ? 'تركمانستان' : 'Turkmenistan' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TM" value="993">
                                                        {{ $i18n.locale == 'العربية' ? 'تركمانستان' : 'Turkmenistan' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="TV" value="688">
                                                        {{ $i18n.locale == 'العربية' ? 'توفالو' : 'Tuvalu' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="UG" value="256">
                                                        {{ $i18n.locale == 'العربية' ? 'أوغندا' : 'Uganda' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="UA" value="380">
                                                        {{ $i18n.locale == 'العربية' ? 'أوكرانيا' : 'Ukraine' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="AE" value="971">{{
                                                            $i18n.locale == 'العربية' ? 'الإمارات' : 'Unitied Arab Emirates'
                                                        }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="UY" value="598">
                                                        {{ $i18n.locale == 'العربية' ? 'أوروغواي' : 'Uruguay' }}
                                                    </option>


                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="UZ" value="7">
                                                        {{ $i18n.locale == 'العربية' ? 'أوزبكستان' : 'Uzbekistan' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="VU" value="678">
                                                        {{ $i18n.locale == 'العربية' ? 'فانواتو' : 'Vanuatu' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="VA" value="379">
                                                        {{ $i18n.locale == 'العربية' ? 'الفاتيكان' : 'Vatican City' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="VE" value="58">
                                                        {{ $i18n.locale == 'العربية' ? 'فنزويلا' : 'Venezuela' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="VN" value="84">
                                                        {{ $i18n.locale == 'العربية' ? 'فيتنام' : 'Vietnam' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="VG" value="84">{{
                                                            $i18n.locale == 'العربية' ? 'جزر العذراء البريطانية' : 'Virgin Islands - British'
                                                        }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="VI" value="84">{{
                                                            $i18n.locale == 'العربية' ? 'جزر العذراء الأمريكية' : 'Virgin Islands - US'
                                                        }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="WF" value="681">{{
                                                            $i18n.locale == 'العربية' ? 'واليس وفوتونا' : 'Wallis &amp; Futuna'
                                                        }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="YE" value="969">
                                                        {{ $i18n.locale == 'العربية' ? 'اليمن الشمال' : 'Yemen (North)' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="YE" value="967">
                                                        {{ $i18n.locale == 'العربية' ? 'اليمن الجنوب' : 'Yemen (South)' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="ZM" value="260">
                                                        {{ $i18n.locale == 'العربية' ? 'زامبيا' : 'Zambia' }}
                                                    </option>

                                                    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                            data-countryCode="ZW" value="263">
                                                        {{ $i18n.locale == 'العربية' ? 'زيمبابوي' : 'Zimbabwe' }}
                                                    </option>
                                                </select>



<!--                                                <label :style="$i18n.locale == 'العربية' ? 'font-family:  Cairo!important;float: right;direction:rtl;right:0;color: rgb(153, 153, 153);':'float: left;direction:ltr;left:0;color: rgb(153, 153, 153);'">-->
<!--                                                    {{-->
<!--                                                        $i18n.locale == 'en' ? 'Country' : $i18n.locale == 'العربية' ? 'موضوع' : $i18n.locale == '中文' ? '主题' : 'Sujet'-->
<!--                                                    }}-->

<!--                                                </label>-->
                                            </div></div>
                                                   </td>
                                            </tr>
                                                <tr>
                                                    <td style="border:0">
                                                        <label :style="$i18n.locale == 'العربية' ? 'font-family:  Cairo!important;float: right;direction:rtl;right:0':'float: left;direction:ltr;left:0'">
                                                            {{
                                                                $i18n.locale == 'en' ? 'Mobile' : $i18n.locale == 'العربية' ? 'رقم الهاتف' : $i18n.locale == '中文' ? '主题' : 'Sujet'
                                                            }}

                                                        </label>
                                                        <div><input :style="$i18n.locale == 'العربية' ? 'width: 100%;height: 55px;margin: 0px auto;border: 2px black solid;border-radius: 10px;text-align: right !important;'
 :'width: 100%;height: 55px;margin: 0px auto;border: 2px black solid;border-radius: 10px;text-align: left !important;'"  v-model="friendmobile" name="subject" type="text" autocomplete="nope"
                                                                    placeholder="Mobile" >
                                                           </div>
                                                    </td>
                                                </tr>


                                            </table>
                                            <div class="buttonHolder" style="text-align: center;">
                                                <button  :disabled="this.isDisabled" type="button" :style="$i18n.locale == 'العربية' ? 'float: right;direction:rtl;':'float: left!important;direction:ltr;'"  class="style__ButtonWrap-sc-1i4p4w8-0 UOTGs" @click="referalfriendregister()"><span
                                                    class="caption">
                                                {{
                                                        $i18n.locale == 'en' ? 'Submit' : $i18n.locale == 'العربية' ? 'قدم' : $i18n.locale == '中文' ? '提交' : 'Envoyer votre demande'
                                                    }}
                                                </span></button>
                                            </div>


                                            <p style="color:green" v-if="this.referfriendsuccess">{{referfriendsuccess}}</p>


                                        </form>
                                    </div>
</div>

  </transition>
                        </div>
                    </div>

                        </div>

                    </div>
                </div>
            </section>




            <Footer/>
        </div>

    </div>

</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
    name: 'webinar',
    data() {
        return {

            pagedata: '',
            pageblocksdata: '',
            contactdata: '',
            contractcat: '',
            contractspecdetails: '',
            webinarsprevious: '',
            firstname: '',
            lastname:'',
            email: '',
            mobile: '',
            country: '',
            countryname:'',
            friendfirstname: '',
            friendmobile: '',
            friendemail: '',
            friendcountry: '',
            referfriendsuccess:'',
            friendcountryname:'',
            show: false,
            show1: false


        }
    },
    components: {
        Header,
        Footer
    },
    mounted() {

        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', 'https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js')
        document.head.appendChild(recaptchaScript)
    },
    beforeMount() {
        if (document.cookie != "") {
            var cookies = document.cookie.split(";");
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].trim().split("=");

                if (cookie[0] == 'registername') {
                    this.registername = cookie[1];
                }
                if (cookie[0] == 'registermobile') {
                    this.registermobile = cookie[1];
                }
                if (cookie[0] == 'registeremail') {
                    this.registeremail = cookie[1];
                }
                if (cookie[0] == 'registercountry') {
                    this.registercountry = cookie[1];
                }
            }

        }
        if (localStorage.getItem('prevuserlogin') == 1) {
            this.prevuserlogin = 1;
        }
        if (localStorage.getItem('webinarpageregisterflag')) {
            this.webinarpageregisterflag = true;
            // alert(this.webinarpageregisterflag)
        }

        var pathvalues = (this.$route.path).split("/");


        if (pathvalues[1] == 'ar') {
            this.$i18n.locale = 'العربية';
        }
        if (pathvalues[1] == 'ch') {
            this.$i18n.locale = '中文';
        }
        if (pathvalues[1] == 'fr') {
            this.$i18n.locale = 'Français';
        }
        this.langchange = this.$i18n.locale;
        this.pagenameroute = pathvalues[4];
        this.loadpagedata(pathvalues[2]);

    },

    methods: {

        onChange(event) {
           // var optionValue = event.target.value;
           // var optionText = event.target.options[event.target.options.selectedIndex].text;
            this.countryname=event.target.options[event.target.options.selectedIndex].text;
           // alert( this.registercountryname)

        },
         onChangefriend(event) {
           // var optionValue = event.target.value;
           // var optionText = event.target.options[event.target.options.selectedIndex].text;
            this.friendcountryname=event.target.options[event.target.options.selectedIndex].text;
           // alert( this.registercountryname)

        },


        referalfriendregister() {

            this.referfriendsuccess = ""


            this.$axios.get("referalfriendregister", {
                params: {
                    firstname: this.firstname,
                    lastname: this.lastname,
                    email: this.email,
                    mobile: this.country + this.mobile,
                    country: this.countryname,
                    friendfirstname: this.friendfirstname,
                     friendemail: this.friendemail,
                     friendmobile: this.country+this.friendmobile,
                     friendcountry: this.friendcountryname ,

                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)

                        if (res.data.code == 200) {

                            if(this.$i18n.locale =='العربية')
                            {
                                this.referfriendsuccess = "شكراً لك على التسجيل. يرجى التحقق البريد الوارد الخاص بك ";
                            }
                            else{
                                this.referfriendsuccess = "Thank you for register. Please check your inbox";
                            }


                            this.email = null;
                            this.firstname = null;
                            this.lastname = null;
                            this.email = null;
                            this.mobile = '965';
                            this.country = 'Kuwait';
                            this.friendfirstname=null;
                            this.friendemail=null;
                            this.friendmobile='965';
                            this.friendcountryname ='Kuwait';


                        } else {
                            this.referfriendsuccess = "Error with Register. Please Register after some time";

                        }


                    }
                });
        },


        loadpagedata(pagename) {

            this.$axios.get("loadpagedata", {
                params: {
                    pagename: pagename
                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)
                        this.pagedata = res.data.pagedata[0];
                        this.currencydata = res.data.currencydata;
                        this.crossesdata = res.data.crossdata;
                        this.currentdate = res.data.currentdate;
                        this.dayname = res.data.dayname;
                        this.daynamear = res.data.daynamear;

                    }
                });


        },
    }
}
</script>

<style>
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}


th {
    background-color: #005060;
    color: #ffffff;
}

tbody tr:nth-child(even) {
    background-color: #f2f2f2;
}

.carousel {
    background: #2f4357;
    margin-top: 20px;
}

.carousel-item {
    text-align: center;
    min-height: 280px; /* Prevent carousel from being distorted if for some reason image doesn't load */
}

.rtlclass {
    direction: rtl !important;
}

.ltrclass {
    direction: ltr !important;
}

select {
    width: 150px;
    line-height: 49px;
    height: 38px;
    font-size: 22px;
    outline: 0;
    margin-bottom: 15px;
}

.p {
    animation-fill-mode: both;
    animation-duration: 1000ms;
    animation-delay: 0ms;
    animation-iteration-count: 1;
    opacity: 1;
    animation-name: slideInUp;
}

#tabela th, td {
    padding: 10px!important;
}

tabela tr:nth-child(even) {
   background-color:none!important;
}

a:hover, a:focus {
    text-decoration: none;
    outline: none;
}

#accordionswap .panel-title a::before {

    content: "+";
    font-family: "Font Awesome 5 Free";
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    background: rgb(45, 174, 202) none repeat scroll 0% 0%;
    font-size: 12px;
    font-weight: 900;
    color: #ffffff;
    text-align: center;
    box-shadow: inset 0 0 10px rgba(0,0,0,0.5);
    text-shadow: none;
    position: absolute;
    top: 8px;
    left: 15px;

}
#accordionswap .panel-title a {
    display: block;
    padding: 12px 15px 12px 50px;
    background: rgb(45, 174, 202) none repeat scroll 0% 0%;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 18px;
    font-weight: 200;
    color: #ffffff;
    text-shadow: 0px 0px 0px #fff;
    position: relative;
}
#accordionsmarket .panel-title a::before {

    content: "+";
    font-family: "Font Awesome 5 Free";
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    background: rgb(45, 174, 202) none repeat scroll 0% 0%;
    font-size: 12px;
    font-weight: 900;
    color: #ffffff;
    text-align: center;
    box-shadow: inset 0 0 10px rgba(0,0,0,0.5);
    text-shadow: none;
    position: absolute;
    top: 8px;
    left: 15px;

}
#accordionsmarket .panel-title a {
    display: block;
    padding: 12px 15px 12px 50px;
    background: rgb(45, 174, 202) none repeat scroll 0% 0%;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 18px;
    font-weight: 200;
    color: #ffffff;
    text-shadow: 0px 0px 0px #fff;
    position: relative;
}
#accordion .panel {
    border: none;
    border-radius: 3px;
    box-shadow: none;
    margin-bottom: 15px;
}

#accordion .panel-heading {
    padding: 0;
    border: none;
    border-radius: 3px;
}

#accordion .panel-title a {
    display: block;
    padding: 12px 15px 12px 50px;
    background: #ffffff;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 22px;
    font-weight: bold;
    color: #005060;
    text-shadow: 0px 0px 0px #fff;
    position: relative;

}

#accordion .panel-title a:before {
    content: "-";
    font-family: "Font Awesome 5 Free";
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    background: #929191;
    font-size: 12px;
    font-weight: 900;
    color: #fdfbfb;
    text-align: center;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
    text-shadow: none;
    position: absolute;
    top: 8px;
    left: 15px;
}

#accordion .panel-title a.collapsed:before {
    content: "+";
}

#accordion .panel-body {
    padding: 10px 15px;
    font-size: 15px;
    color: #222;
    line-height: 27px;
    border: none;
}

#accordion .panel-body p {
    margin-bottom: 0;
}

#analysis {
    content: " ";
    width: 100%;
    position: relative;
    left: 0px;
    margin-top: -60px;
    /*background-color: #0a558c!important;*/
    background: url("https://dev.marketequityinc.com/public/public/analysis.png");
    padding: 45px 0px 0px;
}
#analysis:hover {
    border-top: 0;
    border-bottom: 1px solid #d0d0d0;
    border-left: 1px solid #d0d0d0;
    border-right: 1px solid #d0d0d0;
    border-style: inset;
}
#analysiscrosses {
    content: " ";
    width: 100%;
    position: relative;
    left: 0px;
    margin-top: -60px;
    /*background-color: #0a558c!important;*/
    background: url("https://dev.marketequityinc.com/public/public/analysis.png");
    padding: 45px 0px 0px;

}
#analysiscrosses:hover {
    border-top: 0;
    border-bottom: 1px solid #d0d0d0;
    border-left: 1px solid #d0d0d0;
    border-right: 1px solid #d0d0d0;
    border-style: inset;
}
#analysisarticle {
    content: " ";
    width: 100%;
    position: relative;
    left: 0px;
    margin-top: -60px;
    /*background-color: #0a558c!important;*/
    background: url("https://dev.marketequityinc.com/public/public/analysis.png");
    padding: 45px 0px 0px;

}

#analysisarticle:hover {
    border-top: 0;
    border-bottom: 1px solid #d0d0d0;
    border-left: 1px solid #d0d0d0;
    border-right: 1px solid #d0d0d0;
    border-style: inset;
}
#accordionfaq .panel {
    border: none;
    border-radius: 3px;
    box-shadow: none;
    margin-bottom: 0px;
}

#accordionfaq .panel-heading {
    padding: 0;
    border: none;
    border-radius: 3px;
}

#accordionfaq .panel-title a {
    display: block;
    padding: 2px 15px 0px 2px;
    background: #ffffff;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 22px;
    font-weight: bold;
    color: #005060;
    text-shadow: 0px 0px 0px #fff;
    position: relative;

}
#accordionfaq .panel-title a p {
    margin-bottom: 11px!important;
  margin-left: 57px !important;
  margin-right: 57px !important;
}

#accordionfaq .panel-title a p::before {

    content: "+";
    font-family: "Font Awesome 5 Free";
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    background: rgb(45, 174, 202) none repeat scroll 0% 0%;
    font-size: 12px;
    font-weight: 900;
    color: #ffffff;
    text-align: center;
    box-shadow: inset 0 0 10px rgba(0,0,0,0.5);
    text-shadow: none;
    position: absolute;
    top: 8px;

}
#accordionfaq .panel-title a p::after {

    content: "+";
    font-family: "Font Awesome 5 Free";
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    background: rgb(45, 174, 202) none repeat scroll 0% 0%;
    font-size: 12px;
    font-weight: 900;
    color: #ffffff;
    text-align: center;
    box-shadow: inset 0 0 10px rgba(0,0,0,0.5);
    text-shadow: none;
    position: absolute;
    top: 8px;

}
.kVMyZl ul li::before {
    width: 24px;
    height: 16px;
}
.kVMyZl ul li::before {
    background: rgba(0, 0, 0, 0) url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQCAYAAAAMJL+VAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkVBRDA2NjA4QTkyNTExRTlCQTlCRDRBRkUyNDkxRkU3IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkVBRDA2NjA5QTkyNTExRTlCQTlCRDRBRkUyNDkxRkU3Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RUFEMDY2MDZBOTI1MTFFOUJBOUJENEFGRTI0OTFGRTciIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RUFEMDY2MDdBOTI1MTFFOUJBOUJENEFGRTI0OTFGRTciLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5/utXoAAABT0lEQVR42qzUSyhEURjA8euQlZ1iQ1ZKs7KYMnkszcpCI5mVx4LdKFlYKVYsZCNlJQsbREYpz5IsTEkWFrNSysaCpCyYpuv/1adu08ncuXNO/Tr38fV999zzqPF93wu2zoM7r5r2kIpLjkYuV3FoPMeN5C10JxjCR53j/DEcoxYJRvPocgQ9uMU7uiW5PHRVYAAXyCFJ8pe/Fy4KjOFIDZL8Lfiy2gKz2MI60vgqDTDMekpESL6MFSwgA98WJCNIYJ8ifSET12MTc5jG4n/BUmAeV9ijSGuZ5A0Sh3GMYK3c1xgm5Vv/3w929AttrQln6Fe7YYZrdHu/0g2jCxuWuHbcoA29uAw7USZwhuR0yU1gJhATxzUKkHm6r2QlmJKDaptuSQ+qpO7Oczzrb3mqdKnZziKZ9A6c6n0Wo/iMslFsBYqYRDPymNJnkdqvAAMABqdQ+HPTgMsAAAAASUVORK5CYII=") no-repeat scroll right center / contain;
    content: " ";
    position: absolute;
    width: 18px;
    height: 14px;
    top: 8px;
    right: 0px;
}
/*!sc*/
.kVMyZl {
    position: relative;
    text-align: right;
    background-size: cover;
}

/*!sc*/
.kVMyZl p {
    margin-bottom: 25px;
}

/*!sc*/
.kVMyZl ul, .kVMyZl p, .kVMyZl ol {
    font-weight: 300;
    color: #000;
    font-size: 16px;
    line-height: 34px;
    font-weight: 400;
}

/*!sc*/
.kVMyZl ul {
    padding: 0 0 0 5px;
}

/*!sc*/
@media (min-width: 768px) {
    .kVMyZl ul {
        padding: 0 0 0 20px;
    }
}

/*!sc*/
.kVMyZl li {
    list-style: none;
    position: relative;
    margin-bottom: 10px;
    padding-right: 30px;
}

/*!sc*/
@media (min-width: 768px) {
    .kVMyZl li {
        padding-right: 40px;
    }
}

/*!sc*/
.kVMyZl ul li:before {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQCAYAAAAMJL+VAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkVBRDA2NjA4QTkyNTExRTlCQTlCRDRBRkUyNDkxRkU3IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkVBRDA2NjA5QTkyNTExRTlCQTlCRDRBRkUyNDkxRkU3Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RUFEMDY2MDZBOTI1MTFFOUJBOUJENEFGRTI0OTFGRTciIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RUFEMDY2MDdBOTI1MTFFOUJBOUJENEFGRTI0OTFGRTciLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5/utXoAAABT0lEQVR42qzUSyhEURjA8euQlZ1iQ1ZKs7KYMnkszcpCI5mVx4LdKFlYKVYsZCNlJQsbREYpz5IsTEkWFrNSysaCpCyYpuv/1adu08ncuXNO/Tr38fV999zzqPF93wu2zoM7r5r2kIpLjkYuV3FoPMeN5C10JxjCR53j/DEcoxYJRvPocgQ9uMU7uiW5PHRVYAAXyCFJ8pe/Fy4KjOFIDZL8Lfiy2gKz2MI60vgqDTDMekpESL6MFSwgA98WJCNIYJ8ifSET12MTc5jG4n/BUmAeV9ijSGuZ5A0Sh3GMYK3c1xgm5Vv/3w929AttrQln6Fe7YYZrdHu/0g2jCxuWuHbcoA29uAw7USZwhuR0yU1gJhATxzUKkHm6r2QlmJKDaptuSQ+qpO7Oczzrb3mqdKnZziKZ9A6c6n0Wo/iMslFsBYqYRDPymNJnkdqvAAMABqdQ+HPTgMsAAAAASUVORK5CYII=) no-repeat;
    background-position: right center;
    background-size: contain;
    content: " ";
    position: absolute;
    width: 18px;
    height: 14px;
    top: 8px;
    right: 0;
}

/*!sc*/
@media (min-width: 768px) {
    .kVMyZl ul li:before {
        width: 24px;
        height: 16px;
    }
}

/*!sc*/
.kVMyZl ul li.cross:before {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQCAYAAAAMJL+VAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBCQzdBNzFGRDE0NTExRTk5Qzc1QTQ1MEVEMTQ5ODMzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjBCQzdBNzIwRDE0NTExRTk5Qzc1QTQ1MEVEMTQ5ODMzIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MEJDN0E3MUREMTQ1MTFFOTlDNzVBNDUwRUQxNDk4MzMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MEJDN0E3MUVEMTQ1MTFFOTlDNzVBNDUwRUQxNDk4MzMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz66BrXQAAABZ0lEQVR42rSUvUvDQBiHNYiTm2AXoVOXTg4ZxOqoUwU/BgUHcXNy8A9xEAdHF0EyqDiVailVBwtSHDoXCqWg0NJBFzvE5+AnhJgml4IHDy9378fv7nJvJn3fn/jPMRVeWLh+3cRswPHblttjblNnFk7glpyboMOJCB7ANpQoPm9R3MSUlDMIO/8IsIMqZhEy8AT5mOJ5xWSUU00UkEgTswR9eIFCRFhBvr5im1G1nFFbQ6SDWYM6PEAx4C5qra6Yzqg6Ttzlmo+sD34n9sXv3Ph6qV5RxPiCXfiAC62dwREkvnHH8jn7EgqK+mP1QcSYhnM40K7NOIU5OITvsQXogxnMJazDDnhyvcOVGmwPPlNfEcXNDsuwKryA2wusl3UaewGK5zDPkIVlqESEVeTLKjZnJUBxF/MIQ1iBRswtNhQzVI5rc4J7aJvj0wcti0fQ0lW1lZsoUDPdSfFuir9yVx1dCzt+BBgAXR5gFqIiaRoAAAAASUVORK5CYII=) no-repeat;
    background-position: right center;
    background-size: contain;
}

/*!sc*/
.kVMyZl ol {
    list-style: decimal;
    padding-left: 20px;
}

/*!sc*/
.kVMyZl ol li {
    list-style: decimal;
    padding-left: 10px;
}

/*!sc*/
.kVMyZl h3 {
    text-transform: capitalize!important;
}
.kNCxBo{
    max-width:100%!important;

}
.ZBsdR {

    padding-left: 0px!important;
    padding-right: 0px!important;
    padding-bottom:2%!important;
}
.fHTiUO h3
{
     text-transform: capitalize!important;
}
.fHTiUO ul, .fHTiUO p, .fHTiUO ol {
}
.kcvceY h2 {

}
.JMaKG > div::before {
    background: #4dd1f0;
    content: " ";
    width: 1px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    left: 0;
    background: rgb(77, 209, 240) none repeat scroll 0% 0%;
    content: " ";
    width: 1px;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
}
.JMaKG > div::after {
    background: #fff;
    content: " ";
    width: 57px;
    height: 57px;
    position: absolute;
    top: 50%;
    border-bottom: 1px solid #4dd1f0;
    border-right: 1px solid #4dd1f0;
    display: none;
    left: -28px;
    -webkit-transform: translateY(-50%) rotate(-45deg);
    -ms-transform: translateY(-50%) rotate(-45deg);
    transform: translateY(-50%) rotate(-45deg);
    background: rgb(255, 255, 255) none repeat scroll 0% 0%;
    content: " ";
    width: 57px;
    height: 57px;
    position: absolute;
    top: 50%;
    border-bottom: 1px solid rgb(77, 209, 240);
    border-right: 1px solid rgb(77, 209, 240);
    display: none;
    right: -28px;
    transform: translateY(-50%) rotate(135deg);
}
.FCFMu::before {
    content: " ";
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAA3CAYAAAB3lahZAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkM5RDQ1OUI2QUY4NjExRTlBMDk4QzMwMTIwMUFBNDI4IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkM5RDQ1OUI3QUY4NjExRTlBMDk4QzMwMTIwMUFBNDI4Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QzlENDU5QjRBRjg2MTFFOUEwOThDMzAxMjAxQUE0MjgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QzlENDU5QjVBRjg2MTFFOUEwOThDMzAxMjAxQUE0MjgiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4wjPRSAAAEPklEQVR42tSaa0gUURTH746CkVlJ2TuEsgd+kErohRFaRCVSERamBUH5JZIopSihB5T1wV7Uh8KKwKAHFGEgURAFZYmE2Bt72VMtM9LS0nX7nzob47rrzL0zuzsd+HtZ5+6c35yZe+85d9bl8XiEivU7Xq7/OAIaC42CxvNnF9QIPYPeQS+gt9Afh625C5T8Rgp1mwRlQLOhRGgYQwayz9BT6BZ0BRd8D9Bdsk5dMhGGE7rALCgXmgFFWLjg+9AJ6DTAv9sODNiZaPZwRO20amgroMttAQZoFJpd0CaLETUyinYBwJuVgQE7AU0JlCJCY4+gtYCukAYGbAIauk0JIrRGgzMd0JWmgQEbj+YaNE6Exz5B8wBdbQgM2DieeiaK8Np7KBXQtUbApWiyFZ08hCp4sWiDYqEkaBoUr3C+GxzpTr8LB2CzFWFv8kxCd6bTz/H+0DKoUBI8FcqH9vaIMGCjeZTKRuIQT3luE32HQGeguRLnb6HHE1H+QB803YF1CrD7oQ0mYQXnFplQlYSPGGhHtwgjupSsPIYGSJzoLs/PboVHiHIPmraiTfannGMyolzjjfBiSVjBy7RbcXBScA5K9Ne8Y8sLnCnp8CXP01ashGcSs7aI0gQNf0bjw1RJZ5egdiu0uL2veZCbNcqzkzTOa/tK+ntg0+JQJ5MKU2AJOFnBUbtNwG2S/ZM1xXxhoE3AsZL9EzSuv2RtllVSrl5kgzWIgIcq+FvIq5YVm6KQusYQcB/FW5ltEbjQZ6U1YxGawoPvtQJopOJ3M7nilrUOAv6o6HQ4dBYaLPk9qraPKfps0ThRVrUUXvESTfZPhy4rzA5ea9A42bZitPDcgYp4IEX5HKccJQ06TxsoUJwFX/WRkqleICOoLdBm6DmvYG08X4+x8Kz3WBkJuAb6xlWBVXPx3Bqs4rVGQxJSb1OUg20/KAf3zoNl/wFwJYJbpwf+5XDgC/8SeJDT3u0pB8M2QOd8i9B90E+HAhchqE3dgPGPV2hKHQhLlclJfXGnN9oM+eow4O0IZotfYBx4g+aAg2CreONFBIqwd3PECfMyrZR5CKK7V2B0aEWzgle/cNpGfxvbWoASvFa/PRQGux4oBTV6ZXARzZIQw1J+Pp3HkzAVYZ2tEX9fT4XKaA9tdSBYQ2B88QuaHKgpRMA0yK721sGwCMQJnnDBGexcoxi+jhp1MlW18lXnBRG2jItaYQswQ9OozQ8CLL1ay8H5PbYCM3Qxmp02wtI7keU4r+k536Xy8wNMd4fRrLcIS5vaaYBtkPmSpuIJTvI4HVW129AcWVgyK7+XoCqZXnFtU4DNMHoJbmuEdUb7Y7sln9mlULOqQ82GgVPIz7PRYKCNlPlc7ohwApMdgVZCHQGO028hsoT6xqPtwIITbdqRbPT5P02DuZwnCCcBk9GKSPtotJzTe5BVnKZ22eXgtwADAHGRPl1y1ID4AAAAAElFTkSuQmCC) no-repeat left center;
    background-size: auto;
    position: absolute;
    background-size: contain;
    width: 30px;
    height: 55px;
    top: 0;
    right: 0;
}
.ecLciw > div {
    width: 60%!important;

    padding-right: 5%!important;
    margin-right:1%!important;
}
.ZBsdR strong {
    font-weight: bold!important;

}
.kKgHVc .spotlight__info > div {
    text-align: left!important;
}
.kKgHVc > div p{
    font-family: Comfortaa !important;
}
.fHTiUO p {
    font-family: Comfortaa !important;
}
.fHTiUO p span {
    font-family: Comfortaa !important;
}
.fHTiUO  span {
    font-family: Comfortaa !important;
}
.cDscbW .spotlight__info p {
    text-transform:capitalize!important;

}
.kcvceY {
text-align:left!important;
}
.kcvceY h2, .lcaeBj h3 a, .lpdeLb > div h3 {
    text-transform: capitalize !important;
}
.cDscbW > figure::after {
    z-index: -1!important;
}
.ifRyix > div .thumbOverlay {
       background-color: #1a859d!imortant;
    border-radius: 50%!important;
    width: 300px!important;
    height: 300px!important;
}
.ifRyix > div::before{
    border:0px!important;
}

.ifRyix > div::after{
    border:0px!important;
}

.ifRyix > div .deposit{
 border-radius: 50%!important;
    width: 300px!important;
    height: 300px!important;
}

.ifRyix > div .thumbOverlay .btn_wrap a, .ifRyix > div .thumbOverlay .btn_wrap span{
    background: transparent!important;
}
.fHTiUO p {

    padding-left: 5%!important;
    padding-right: 5%!important;
    color: #151414!important;
}
.ifRyix > div .details_wrap {

    cursor: pointer!important;
}
.htlbQg {
    padding-top: 0px!important;
}
.fHTiUO {
    margin-bottom: -5%!important;
}
.dIoETn{
    padding-bottom:5%!important;
}
.ZBsdR strong{
    font-family: inherit !important
}
.kVMyZl ol, .kVMyZl p, .kVMyZl ul{
     font-family: inherit !important
}
.hqzysg a span{
       font-family: inherit !important

}
.cDscbW .spotlight__info p{
           font-family: inherit !important

}
.kNCxBo{
        background-image: url(https://devbackup.marketequityinc.com/public/public/129/20210614094716aboutusbg.png)!important;

}
</style>
<style>

@media screen and (max-width : 1920px){
  .div-only-mobile{
  display:none;
  }
  .desk{
 display:block;
  }
}
@media screen and (max-width : 906px){
 .desk{
 display:none;
  }
 .div-only-mobile{
display:block;
}
}
.carousel-indicators li {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #dcd9d9;
}
  </style>

